/* reviewify-widget v6 (script) — written by OpenWeav (Reviewify → Re-deploy). Do not edit: Re-deploy replaces this file. */

(function() {
  'use strict';

  // Once per page — for the SAVED copy only. While a store moves from the
  // openweav.com tag to the store-hosted copy (assets/reviewify-widget.js) a
  // page can carry this script twice (a legacy ScriptTag, a leftover block).
  // The copy that DRAWS the store's saved reviews claims the page (the flag is
  // set right where it draws them) and a later copy steps aside. A copy that
  // gives up early (no product id yet, not a product page) never blocks a
  // later one, and on a page without saved reviews nothing is claimed: every
  // copy runs exactly as before 2026-09-24 (the renderers' own "don't inject
  // twice" checks keep one badge and one section).
  if (window.__reviewifyLoaded) return;

  // Widget v6 (storefront audit WP6): on a product with a saved copy the
  // theme block reserves the star line's space under the title
  // (html:not(.rvfy-badge-in) … padding-bottom), so the badge never pushes the
  // price and the buy button down. This class releases the reserve — in the
  // SAME task as the badge insert, and on every path that draws no badge.
  function rvfyReleaseBadge() {
    try { document.documentElement.classList.add('rvfy-badge-in'); } catch (e) {}
  }

  // ── Configuration ──
  var REVIEWIFY_API = 'https://openweav.com/api/reviewify';

  // ── Resolve store slug + workspace from the script tag's data attributes ──
  // The installer bakes data-reviewify-store (and, for tenants, data-reviewify-ws)
  // onto the <script> tag so the widget works on ANY domain without a hardcoded map.
  //
  // THE BUG THAT WAS HERE. This script used to carry a STORE_MAP literal of the
  // owner's storefront hostnames → slugs and fall back to it when the tag had no
  // slug. One widget.js is served byte-identical to EVERY storefront, so that map
  // shipped the owner's live domains to every tenant's shoppers — and did nothing
  // for them: a tenant's hostname was never a key, so the lookup returned
  // undefined, the script bailed out, and the reviews a tenant had imported never
  // rendered for a single customer. The baked attribute is authoritative now.
  var scriptEl = document.querySelector('script[data-reviewify-store]');
  var storeSlug = scriptEl ? scriptEl.getAttribute('data-reviewify-store') : null;
  var workspaceId = scriptEl ? scriptEl.getAttribute('data-reviewify-ws') : null;

  // Legacy tags (installed before the data attribute existed) have no slug: send
  // the hostname instead and let the server resolve it — the map moved there, so
  // it can be answered per workspace instead of shipped to every shopper. The
  // response echoes the resolved slug back on data.storeSlug. An unrecognized
  // host 404s and nothing renders, exactly as the missing map key did before.
  var STORE_QS = storeSlug
    ? 'store=' + encodeURIComponent(storeSlug)
    : 'host=' + encodeURIComponent(window.location.hostname);

  // Query-string suffix carrying the workspace id (when present) for scoped reads.
  var WS_QS = workspaceId ? ('&ws=' + encodeURIComponent(workspaceId)) : '';

  // ── Detect product page and get product ID ──
  var meta = document.querySelector('meta[property="og:type"][content="product"]');
  if (!meta) {
    console.log('[Reviewify] Not a product page, skipping');
    rvfyReleaseBadge();
    return;
  }

  // Get Shopify product ID — multiple detection strategies
  var productId = null;

  // Strategy 1: __st global (most reliable, always present on Shopify pages)
  if (window.__st && window.__st.rid && window.__st.p === 'product') {
    productId = String(window.__st.rid);
    console.log('[Reviewify] Product ID from __st.rid:', productId);
  }

  // Strategy 2: ShopifyAnalytics.meta
  if (!productId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
    productId = String(window.ShopifyAnalytics.meta.product.id);
    console.log('[Reviewify] Product ID from ShopifyAnalytics:', productId);
  }

  // Strategy 3: window.meta.product
  if (!productId && window.meta && window.meta.product) {
    productId = String(window.meta.product.id);
    console.log('[Reviewify] Product ID from window.meta:', productId);
  }

  // Strategy 4: productGid in page scripts
  if (!productId) {
    var allScripts = document.querySelectorAll('script');
    for (var s = 0; s < allScripts.length; s++) {
      var txt = allScripts[s].textContent || '';
      var gidMatch = txt.match(/gid:\/\/shopify\/Product\/(\d+)/);
      if (gidMatch) {
        productId = gidMatch[1];
        console.log('[Reviewify] Product ID from GID:', productId);
        break;
      }
    }
  }

  // Strategy 5: parse from product JSON in page
  if (!productId) {
    var jsonScripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < jsonScripts.length; i++) {
      try {
        var data = JSON.parse(jsonScripts[i].textContent || '');
        if (data && data.product && data.product.id) {
          productId = String(data.product.id);
          console.log('[Reviewify] Product ID from JSON:', productId);
          break;
        }
      } catch(e) {}
    }
  }


  // ── Saved reviews: the store's own copy, printed by the theme ──
  function rvfyUrl(u) {
    if (typeof u !== 'string') return null;
    var v = u.trim();
    if (!v || v.length > 500) return null;
    return /^https?:\/\/[^\s"'<>\\]+$/i.test(v) ? v : null;
  }

  function rvfyNum(n, min, max, dflt) {
    var x = Number(n);
    if (n === null || n === '' || !isFinite(x)) return dflt;
    if (x < min) return min;
    if (x > max) return max;
    return x;
  }

  function rvfyNormalizeReview(r) {
    if (!r || typeof r !== 'object') return null;
    var id = Number(r.id);
    if (r.id === null || r.id === '' || !isFinite(id)) return null;
    var photos = null;
    if (Array.isArray(r.buyerPhotos)) {
      photos = [];
      for (var p = 0; p < r.buyerPhotos.length && p < 50; p++) {
        var u = rvfyUrl(r.buyerPhotos[p]);
        if (u) photos.push(u);
      }
    }
    return {
      id: id,
      reviewerName: typeof r.reviewerName === 'string' ? r.reviewerName : '',
      reviewerAvatar: rvfyUrl(r.reviewerAvatar),
      rating: Math.round(rvfyNum(r.rating, 1, 5, 5)),
      reviewText: typeof r.reviewText === 'string' ? r.reviewText : null,
      reviewDate: typeof r.reviewDate === 'string' ? r.reviewDate : null,
      buyerPhotos: photos,
      verifiedPurchase: r.verifiedPurchase === true,
      importedAt: typeof r.importedAt === 'string' ? r.importedAt : ''
    };
  }

  function rvfyNormalizeStats(st) {
    var src = st && typeof st.ratingBreakdown === 'object' && st.ratingBreakdown ? st.ratingBreakdown : {};
    var bd = {};
    for (var k = 1; k <= 5; k++) bd[k] = Math.round(rvfyNum(src[k], 0, 1000000, 0));
    return {
      totalReviews: Math.round(rvfyNum(st ? st.totalReviews : 0, 0, 1000000, 0)),
      averageRating: rvfyNum(st ? st.averageRating : 0, 0, 5, 0),
      ratingBreakdown: bd
    };
  }

  function rvfyNormalizeSnapshot(raw, pidAttr) {
    if (!raw || typeof raw !== 'object' || raw.v !== 1) return null;
    if (!raw.stats || typeof raw.stats !== 'object' || !Array.isArray(raw.reviews)) return null;
    var reviews = [];
    for (var i = 0; i < raw.reviews.length && i < 1000; i++) {
      var n = rvfyNormalizeReview(raw.reviews[i]);
      if (n) reviews.push(n);
    }
    // Two ids: the page's product (data-product-id, printed by the theme) and
    // the product the copy was BUILT for (its own productId). A copy carried
    // over to another product (Shopify "Duplicate", a clone that copies every
    // metafield) holds the ORIGINAL product's reviews: refuse it.
    var attr = (pidAttr !== null && pidAttr !== undefined) ? String(pidAttr) : '';
    var own = (raw.productId !== null && raw.productId !== undefined) ? String(raw.productId) : '';
    if (!/^\d{1,20}$/.test(attr)) attr = '';
    if (!/^\d{1,20}$/.test(own)) own = '';
    if (attr && own && attr !== own) return null;
    var pid = attr || own;
    return {
      productId: pid,
      builtAt: typeof raw.builtAt === 'string' ? raw.builtAt.slice(0, 40) : '',
      truncated: raw.truncated === true,
      stats: rvfyNormalizeStats(raw.stats),
      reviews: reviews
    };
  }

  function rvfyReadSnapshotText(text, pidAttr) {
    try { return rvfyNormalizeSnapshot(JSON.parse(text || ''), pidAttr); } catch (e) { return null; }
  }

  function rvfyReviewSig(r) {
    var n = rvfyNormalizeReview(r);
    if (!n) return '';
    return JSON.stringify([n.id, n.rating, n.reviewerName, n.reviewText, n.reviewDate, n.verifiedPurchase, n.reviewerAvatar, n.buyerPhotos]);
  }

  function rvfyStatsSig(st) {
    return JSON.stringify(rvfyNormalizeStats(st));
  }

  // shown = the saved copy currently on the page (null when none was drawn);
  // data  = the parsed answer of GET /reviews (null/garbage when it failed).
  function rvfyReconcile(shown, data) {
    if (!data || typeof data !== 'object' || !data.stats || typeof data.stats !== 'object' || data.dbUnavailable) {
      return { action: shown ? 'keep' : 'none' };
    }
    var total = Number(data.stats.totalReviews) || 0;
    if (!shown) return { action: total > 0 ? 'render' : 'none' };
    if (total === 0) return { action: 'remove' };
    if (!Array.isArray(data.reviews)) return { action: 'keep' };
    if (rvfyStatsSig(shown.stats) !== rvfyStatsSig(data.stats)) return { action: 'rerender' };
    var n = shown.reviews.length;
    if (data.reviews.length < n) return { action: 'rerender' };
    for (var i = 0; i < n; i++) {
      if (rvfyReviewSig(shown.reviews[i]) !== rvfyReviewSig(data.reviews[i])) return { action: 'rerender' };
    }
    if (data.reviews.length > n) return { action: 'extend', extra: data.reviews.slice(n) };
    return { action: 'keep' };
  }


  // ── Images (widget v5): sized requests from the store's own files ──
  var RVFY_BUCKETS = [64, 96, 128, 192, 256, 320, 384, 512, 640, 768, 1024, 1280, 1600];
  var rvfyFallbackUsed = {};
  var rvfyBroken = {};
  var rvfyLoadedOnce = {};

  function rvfyHas(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }

  function rvfyEsc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function rvfyBucket(px) {
    var n = Math.ceil(Number(px) || 0);
    for (var i = 0; i < RVFY_BUCKETS.length; i++) {
      if (RVFY_BUCKETS[i] >= n) return RVFY_BUCKETS[i];
    }
    return 1600;
  }

  function rvfyOwnShopPath() {
    var st = (typeof window !== 'undefined' && window) ? window.__st : null;
    var a = st && st.a != null ? String(st.a) : '';
    if (!/^\d{1,12}$/.test(a)) return '';
    while (a.length < 12) a = '0' + a;
    return a.slice(0, 4) + '/' + a.slice(4, 8) + '/' + a.slice(8, 12);
  }

  // Drop the sizing parameters (and the cache-busting v) a stored URL may carry.
  function rvfyCleanQuery(u) {
    var h = u.indexOf('#');
    if (h >= 0) u = u.slice(0, h);
    var q = u.indexOf('?');
    if (q < 0) return u;
    var keep = [];
    var parts = u.slice(q + 1).split('&');
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      if (!/^(width|height|crop|v)$/i.test(parts[i].split('=')[0])) keep.push(parts[i]);
    }
    return keep.length ? u.slice(0, q) + '?' + keep.join('&') : u.slice(0, q);
  }

  function rvfySized(base, w, h, how) {
    var q = 'width=' + rvfyBucket(w);
    if (how === 'crop') q += '&height=' + rvfyBucket(h) + '&crop=center';
    else if (how === 'fit') q += '&height=' + rvfyBucket(h);
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + q;
  }

  function rvfyPair(base, w, h, how) {
    var one = rvfySized(base, w, h, how);
    var two = rvfySized(base, w * 2, h * 2, how);
    return { src: one, srcset: two !== one ? one + ' 1x, ' + two + ' 2x' : '' };
  }

  function rvfyImgSet(url, cssW, cssH, how) {
    var u = typeof url === 'string' ? url : '';
    var plain = { src: u, srcset: '', fb: null };
    if (!u || /^(data|blob):/i.test(u)) return plain;
    var set = null;
    var shop = u.match(/^https:\/\/cdn\.shopify\.com\/s\/files\/1\/(\d{4}\/\d{4}\/\d{4})\/([^?#]+)/i);
    if (shop) {
      var abs = rvfyPair(rvfyCleanQuery(u), cssW, cssH, how);
      var own = rvfyOwnShopPath();
      if (own && shop[1] === own) {
        var rel = rvfyPair(rvfyCleanQuery('/cdn/shop/' + u.slice(u.indexOf(shop[2]))), cssW, cssH, how);
        set = { src: rel.src, srcset: rel.srcset, fb: { src: abs.src, srcset: abs.srcset } };
      } else {
        set = { src: abs.src, srcset: abs.srcset, fb: null };
      }
    } else if (/^(https:\/\/[^\/?#]+)?\/cdn\/shop\/[^?#]+/i.test(u)) {
      var cs = rvfyPair(rvfyCleanQuery(u), cssW, cssH, how);
      set = { src: cs.src, srcset: cs.srcset, fb: null };
    } else if (/^https:\/\/[^?#]+-w(1280|640|320)\.jpg$/i.test(u)) {
      var pick = function(px) { return px <= 320 ? 320 : px <= 640 ? 640 : 1280; };
      var s1 = u.replace(/-w(1280|640|320)\.jpg$/i, '-w' + pick(cssW) + '.jpg');
      var s2 = u.replace(/-w(1280|640|320)\.jpg$/i, '-w' + pick(cssW * 2) + '.jpg');
      set = { src: s1, srcset: s2 !== s1 ? s1 + ' 1x, ' + s2 + ' 2x' : '', fb: s1 !== u ? { src: u, srcset: '' } : null };
    } else if (/^https:\/\/[^?#]+[_\/]570xN(?=[.\/])/.test(u)) {
      // An address with a 570-wide size token (a photo not copied yet): the
      // same size ladder the lightbox uses, from size tokens only — a square
      // 300 for small cropped boxes, 794 / 1140 for big boxes — with the
      // 570 address itself as the fallback.
      var tok = function(px) {
        if (how === 'crop' && px <= 300 && /iap_570xN/.test(u)) return '300x300';
        return px <= 570 ? '570xN' : px <= 794 ? '794xN' : '1140xN';
      };
      var swap = function(t) { return u.replace(/([_\/])570xN(?=[.\/])/, function(m, p) { return p + t; }); };
      var e1 = swap(tok(cssW));
      var e2 = swap(tok(cssW * 2));
      set = { src: e1, srcset: e2 !== e1 ? e1 + ' 1x, ' + e2 + ' 2x' : '', fb: (e1 !== u || e2 !== u) ? { src: u, srcset: '' } : null };
    } else {
      return plain;
    }
    if (rvfyHas(rvfyFallbackUsed, u) && set.fb) return { src: set.fb.src, srcset: set.fb.srcset, fb: null };
    return set;
  }

  // attrs: the rest of the tag (class, alt, width, height, loading, decoding …), already escaped by the caller.
  function rvfyImgTag(url, cssW, cssH, how, attrs) {
    var set = rvfyImgSet(url, cssW, cssH, how);
    var h = '<img src="' + rvfyEsc(set.src) + '"';
    if (set.srcset) h += ' srcset="' + rvfyEsc(set.srcset) + '"';
    if (set.fb) {
      h += ' data-rvfy-fb-src="' + rvfyEsc(set.fb.src) + '"';
      if (set.fb.srcset) h += ' data-rvfy-fb-srcset="' + rvfyEsc(set.fb.srcset) + '"';
    }
    return h + ' data-rvfy-u="' + rvfyEsc(url) + '" ' + attrs + ' />';
  }

  // Point an existing <img> at another photo / size (the same attributes rvfyImgTag writes).
  function rvfySetImg(img, url, cssW, cssH, how) {
    var set = rvfyImgSet(url, cssW, cssH, how);
    img.setAttribute('data-rvfy-u', url);
    if (set.fb) img.setAttribute('data-rvfy-fb-src', set.fb.src); else img.removeAttribute('data-rvfy-fb-src');
    if (set.fb && set.fb.srcset) img.setAttribute('data-rvfy-fb-srcset', set.fb.srcset); else img.removeAttribute('data-rvfy-fb-srcset');
    if (set.srcset) img.setAttribute('srcset', set.srcset); else img.removeAttribute('srcset');
    img.setAttribute('src', set.src);
  }

  // A load error: switch ONCE (per element: the fallback attributes are
  // consumed) to the fallback set. The base is remembered so later renders
  // start there; an <img> already on the page with the same base still gets
  // its own one switch. False = no fallback left (the photo is broken).
  function rvfyTryFallback(img, remember) {
    var base = img.getAttribute('data-rvfy-u') || '';
    var fbSrc = img.getAttribute('data-rvfy-fb-src');
    if (!fbSrc) return false;
    if (remember !== false) rvfyFallbackUsed[base] = 1;
    var fbSet = img.getAttribute('data-rvfy-fb-srcset');
    img.removeAttribute('data-rvfy-fb-src');
    img.removeAttribute('data-rvfy-fb-srcset');
    if (fbSet) img.setAttribute('srcset', fbSet); else img.removeAttribute('srcset');
    img.setAttribute('src', fbSrc);
    return true;
  }

  function rvfyLoadedElsewhere(base, except) {
    if (!base || typeof document === 'undefined') return false;
    var all = document.querySelectorAll('img[data-rvfy-u]');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el === except || el.getAttribute('data-rvfy-u') !== base) continue;
      if (el.complete && el.naturalWidth > 0) return true;
    }
    return false;
  }

  function rvfyNoteLoaded(img) {
    var b = img && img.getAttribute ? img.getAttribute('data-rvfy-u') : null;
    if (!b || !(img.naturalWidth > 0)) return;
    rvfyLoadedOnce[b] = 1;
    delete rvfyBroken[b];
  }

  // Mark a base broken for the page: never one the shopper has seen load on
  // this page (a later failed request is the connection, not the photo), and
  // never while another <img> of it shows it. True when marked.
  function rvfyMarkBroken(base, except) {
    if (!base || rvfyHas(rvfyLoadedOnce, base) || rvfyLoadedElsewhere(base, except)) return false;
    rvfyBroken[base] = 1;
    return true;
  }

  function rvfyCanResize(url) {
    var u = typeof url === 'string' ? url : '';
    if (!u || /^(data|blob):/i.test(u)) return false;
    return /^https:\/\/cdn\.shopify\.com\/s\/files\/1\/\d{4}\/\d{4}\/\d{4}\/[^?#]+/i.test(u)
      || /^(https:\/\/[^\/?#]+)?\/cdn\/shop\/[^?#]+/i.test(u)
      || /^https:\/\/[^?#]+-w(1280|640|320)\.jpg$/i.test(u);
  }

  function rvfyLightboxPick(url, w, h) {
    var u = typeof url === 'string' ? url : '';
    if (rvfyCanResize(u)) {
      var set = rvfyImgSet(u, w, h, 'fit');
      return { src: set.src, fb: set.fb ? set.fb.src : null, sized: true };
    }
    var small = u.replace(/75x75|170x135|300x300/, '570xN');
    if (w > 640) {
      var big = small.replace(/([_\/])570xN(?=[.\/])/, function(m, p) { return p + (w > 900 ? '1140xN' : '794xN'); });
      if (big !== small) return { src: big, fb: small, sized: false };
    }
    return { src: small, fb: null, sized: false };
  }

  function rvfyLive(list) {
    var out = [];
    if (!list || !list.length) return out;
    for (var i = 0; i < list.length; i++) {
      if (typeof list[i] === 'string' && list[i] && !rvfyHas(rvfyBroken, list[i]) && out.indexOf(list[i]) < 0) out.push(list[i]);
    }
    return out;
  }

  function rvfyColsFor(w) { return w <= 400 ? 1 : w <= 600 ? 2 : w <= 900 ? 3 : 4; }


  // ── Lists (widget v6): sort from the base order, dates, stars, wording ──
  var RVFY_MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };

  function rvfyParseDateMs(date) {
    var s = (date == null ? '' : String(date)).trim();
    if (!s) return null;
    var named = s.match(/^([A-Za-z]{3,9})\.?\s+(\d{1,2}),?\s*(\d{4})$/);
    if (named) {
      var m = RVFY_MONTHS[named[1].slice(0, 3).toLowerCase()];
      if (m === undefined) return null;
      return Date.UTC(Number(named[3]), m, Number(named[2]));
    }
    var iso = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ].*)?$/);
    if (iso) return Date.UTC(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
    return null;
  }

  // One display format for every date the parser understands ("Aug 30,
  // 2026", from the UTC day — the named form most rows already use); ISO and
  // named dates were mixed on one widget (review 2026-09-25 r4). A date that
  // is not on the calendar ("Feb 31", month 13, a two-digit year the Date
  // object would move to 19xx) or that does not parse is shown exactly as
  // stored.
  var RVFY_MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function rvfyFormatReviewDate(date) {
    var s = date == null ? '' : String(date);
    var ms = rvfyParseDateMs(s);
    if (ms === null || !isFinite(ms)) return s;
    var t = s.trim();
    var y, mo, day;
    var named = t.match(/^([A-Za-z]{3,9})\.?\s+(\d{1,2}),?\s*(\d{4})$/);
    if (named) { y = Number(named[3]); mo = RVFY_MONTHS[named[1].slice(0, 3).toLowerCase()]; day = Number(named[2]); }
    else {
      var iso = t.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!iso) return s;
      y = Number(iso[1]); mo = Number(iso[2]) - 1; day = Number(iso[3]);
    }
    var d = new Date(ms);
    if (d.getUTCFullYear() !== y || d.getUTCMonth() !== mo || d.getUTCDate() !== day) return s;
    return RVFY_MONTH_NAMES[mo] + ' ' + day + ', ' + y;
  }

  function rvfyImportedMs(r) {
    var t = r && r.importedAt ? Date.parse(r.importedAt) : NaN;
    return isFinite(t) ? t : 0;
  }

  function rvfySortReviews(base, mode) {
    var list = [];
    for (var i = 0; i < (base ? base.length : 0); i++) list.push({ r: base[i], i: i, d: rvfyParseDateMs(base[i] && base[i].reviewDate) });
    var cmp;
    if (mode === 'newest') {
      cmp = function(a, b) {
        if (a.d !== b.d) {
          if (a.d === null) return 1;
          if (b.d === null) return -1;
          return b.d - a.d;
        }
        var ia = rvfyImportedMs(a.r), ib = rvfyImportedMs(b.r);
        if (ia !== ib) return ib - ia;
        var da = Number(a.r && a.r.id) || 0, db = Number(b.r && b.r.id) || 0;
        if (da !== db) return da - db;
        return a.i - b.i;
      };
    } else if (mode === 'highest' || mode === 'lowest') {
      var dir = mode === 'highest' ? -1 : 1;
      cmp = function(a, b) {
        var ra = Number(a.r && a.r.rating) || 0, rb = Number(b.r && b.r.rating) || 0;
        if (ra !== rb) return dir * (ra - rb);
        return a.i - b.i;
      };
    } else {
      cmp = function(a, b) { return a.i - b.i; };
    }
    list.sort(cmp);
    var out = [];
    for (var k = 0; k < list.length; k++) out.push(list[k].r);
    return out;
  }

  function rvfyDatedShare(list) {
    if (!list || !list.length) return 0;
    var n = 0;
    for (var i = 0; i < list.length; i++) if (rvfyParseDateMs(list[i] && list[i].reviewDate) !== null) n++;
    return n / list.length;
  }

  function rvfyStarFills(rating) {
    var x = Number(rating);
    if (!isFinite(x)) x = 0;
    if (x < 0) x = 0;
    if (x > 5) x = 5;
    var out = [];
    for (var i = 0; i < 5; i++) {
      var f = x - i;
      if (f < 0) f = 0;
      if (f > 1) f = 1;
      out.push(Math.round(f * 100) / 100);
    }
    return out;
  }

  function rvfyCountLabel(n) {
    var c = Math.max(0, Math.round(Number(n) || 0));
    return c + (c === 1 ? ' review' : ' reviews');
  }

  // Widget v5 (2026-09-24): the photo sets the lightbox opens, by a
  // deterministic key ("strip", "r<reviewId>") — reset on every full render —
  // and the CSS width of a card photo (estimated before the first layout,
  // corrected upward only by the synchronous layout).
  var rvfySets = {};
  var rvfyCardImgW = 0;
  // Widget v6: the current section's layout (one resize listener per page),
  // and the counter that keeps every partial-star gradient id unique.
  var rvfyActiveLayout = null;
  var rvfyResizeBound = false;
  var rvfyResizeTimer = null;
  var rvfyGradSeq = 0;

  function rvfyEstimateCardImgW(mainEl) {
    var mw = mainEl && mainEl.clientWidth ? mainEl.clientWidth : (window.innerWidth || 1200);
    var w = Math.max(1, Math.min(mw - 40, 1200));
    var cols = rvfyColsFor(w);
    return Math.max(32, (w - 16 * (cols - 1)) / cols - 34);
  }

  function rvfyAvatarPlaceholder(name) {
    var nm = String(name || '');
    var avatarColors = ['#c4704b','#7c6f64','#8b5e3c','#6b8e6b','#5b7fa5','#9b6b8e','#b08d57','#6b5e54'];
    var colorIdx = 0;
    for (var ci = 0; ci < nm.length; ci++) { colorIdx += nm.charCodeAt(ci); }
    return '<span class="reviewify-avatar-placeholder" style="background:' + avatarColors[colorIdx % avatarColors.length] + ';color:#fff">' + escapeHtml(getInitials(nm)) + '</span>';
  }

  function rvfyClosest(el, cls) {
    while (el && el.classList && !el.classList.contains(cls)) el = el.parentNode;
    return el && el.classList ? el : null;
  }

  // The lightbox list for a clicked image: its set without broken photos,
  // starting at the clicked photo. A photo the shopper can see (the clicked
  // <img> has loaded) is never treated as broken.
  function rvfyOpenFrom(img) {
    var set = rvfySets[img.getAttribute('data-rvfy-set')] || [];
    var clicked = img.getAttribute('data-rvfy-u') || '';
    if (clicked && img.complete && img.naturalWidth > 0) delete rvfyBroken[clicked];
    var raw = parseInt(img.getAttribute('data-rvfy-index'), 10) || 0;
    var live = [];
    var start = -1;
    var byBase = -1;
    var after = -1;
    for (var i = 0; i < set.length; i++) {
      if (rvfyHas(rvfyBroken, set[i])) continue;
      if (i === raw && set[i] === clicked) start = live.length;
      if (byBase < 0 && set[i] === clicked) byBase = live.length;
      if (after < 0 && i >= raw) after = live.length;
      live.push(set[i]);
    }
    if (start < 0) start = byBase >= 0 ? byBase : after >= 0 ? after : 0;
    if (live.length) openLightbox(live, start);
  }

  // The theme prints the product's saved reviews (metafield reviewify.snapshot)
  // into <script type="application/json" id="reviewify-data"> on product pages
  // of stores installed with the store-hosted widget. It is used only when it
  // belongs to THIS product (a copy built for another product — a duplicated
  // product inherits the metafield — is refused by rvfyNormalizeSnapshot).
  var snapEl = document.getElementById('reviewify-data');
  var snap = snapEl ? rvfyReadSnapshotText(snapEl.textContent, snapEl.getAttribute('data-product-id')) : null;
  if (snap && productId && snap.productId && snap.productId !== productId) {
    console.log('[Reviewify] Saved reviews belong to another product, ignoring them');
    snap = null;
  }
  if (!productId && snap && snap.productId) productId = snap.productId;

  if (!productId) {
    console.log('[Reviewify] Could not detect product ID, skipping');
    rvfyReleaseBadge();
    return;
  }

  console.log('[Reviewify] Loading reviews for ' + STORE_QS + ', productId=' + productId);

  // ── Styles (widget v6): embedded in this file, injected synchronously ──
  // Until v5 the widget loaded a separate stylesheet and drew the section
  // after it loaded or after 2.5 s — a stylesheet that failed (a network
  // hiccup) left grey buttons and 2,560-px photos, a 38,000-px section and a
  // page that scrolled sideways (audit finding 14), and the wait delayed the
  // stars by ~0.3 s. The styles now travel inside the script: the section can
  // never be drawn unstyled and nothing waits. (The store-hosted install still
  // writes the .css file next to the script; this version never loads it.)
  var RVFY_CSS = "\n/* ── Reviewify Widget Styles ── */\n/* Scoped to .reviewify-* classes to avoid theme conflicts */\n\n.reviewify-star-badge {\n  /* v6: a fixed 20-px line (the theme block reserves exactly this under the\n     title until the badge is in); the theme's own margins apply. */\n  display: flex;\n  width: max-content;\n  max-width: 100%;\n  height: 20px;\n  line-height: 20px;\n  align-items: center;\n  gap: 6px;\n  margin: 8px 0 4px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  color: #333;\n}\n.reviewify-badge-rating {\n  font-weight: 600;\n}\n.reviewify-badge-count {\n  color: #666;\n  text-decoration: underline;\n}\n\n.reviewify-section {\n  max-width: 100%;\n  box-sizing: border-box;\n  padding: 40px 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: #333;\n}\n.reviewify-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* ── Summary ── */\n.reviewify-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 30px;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #eee;\n  /* Nothing in the summary may ever widen the page (see photo-strip note). */\n  max-width: 100%;\n  box-sizing: border-box;\n}\n.reviewify-summary > * {\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n.reviewify-summary-left {\n  text-align: center;\n  min-width: 100px;\n}\n.reviewify-avg-rating {\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 1;\n  color: #222;\n}\n.reviewify-avg-stars {\n  margin: 4px 0;\n}\n.reviewify-total-count {\n  font-size: 13px;\n  color: #888;\n}\n\n/* ── Rating breakdown ── */\n.reviewify-breakdown {\n  flex: 1 1 auto !important;\n  min-width: 200px !important;\n  max-width: 400px !important;\n  display: block !important;\n}\n.reviewify-breakdown-row {\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n  margin-bottom: 6px !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n}\n.reviewify-breakdown-stars {\n  flex: 0 0 auto !important;\n  display: inline-flex !important;\n  white-space: nowrap !important;\n}\n.reviewify-breakdown-stars .reviewify-star {\n  width: 14px !important;\n  height: 14px !important;\n}\n.reviewify-bar {\n  flex: 1 1 0% !important;\n  height: 10px !important;\n  min-height: 10px !important;\n  max-height: 10px !important;\n  min-width: 80px !important;\n  background: #e8e8e8 !important;\n  border-radius: 5px !important;\n  overflow: hidden !important;\n  display: block !important;\n}\n.reviewify-bar-fill {\n  height: 100% !important;\n  min-height: 10px !important;\n  background: #f4c01e !important;\n  border-radius: 5px !important;\n  transition: width 0.3s ease !important;\n  display: block !important;\n}\n.reviewify-bar-pct {\n  font-size: 12px !important;\n  color: #888 !important;\n  min-width: 36px !important;\n  text-align: right !important;\n  flex: 0 0 auto !important;\n  white-space: nowrap !important;\n}\n\n/* ── Photo strip ── */\n.reviewify-photo-strip {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  padding: 8px 0;\n  /* A flex item's min-width defaults to its CONTENT width, so 8 thumbs\n     (~570px) stretched the strip past the phone screen and made the WHOLE\n     PAGE pan sideways (owner report 2026-08-28, mobile screenshots: summary\n     cropped right, store header dragged off-screen). Capped, the strip can\n     never exceed its container and its own overflow-x scroll takes over. */\n  max-width: 100%;\n  min-width: 0;\n  flex: 1 1 100%;\n  box-sizing: border-box;\n}\n.reviewify-photo-thumb {\n  width: 64px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.2s;\n  /* v5: a warm tile while the photo loads, and never a visible alt text. */\n  background: #f3efe9;\n  color: transparent;\n}\n.reviewify-photo-thumb:hover {\n  transform: scale(1.05);\n}\n\n/* ── Sort ── */\n.reviewify-sort {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n  font-size: 13px;\n  color: #888;\n}\n.reviewify-sort-select {\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 13px;\n  background: #fff;\n  cursor: pointer;\n}\n\n/* ── Reviews grid (JS masonry) ── */\n.reviewify-grid {\n  position: relative !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n}\n/* v6: one column (phones) is normal flow — no absolute placing. */\n.reviewify-grid.reviewify-grid-flow {\n  height: auto !important;\n}\n.reviewify-grid.reviewify-grid-flow .reviewify-card {\n  position: relative !important;\n  left: auto !important;\n  top: auto !important;\n  width: auto !important;\n  margin-bottom: 16px;\n}\n.reviewify-section img {\n  max-width: 100%;\n}\n@media (max-width: 600px) {\n  /* Mobile: one centered column that respects the screen width, like the\n     review cards below it — never cropped, never panning the page. */\n  .reviewify-summary { flex-direction: column; align-items: center; }\n  .reviewify-summary > * { width: 100%; }\n  .reviewify-breakdown { max-width: 100% !important; }\n  /* flex-start, NOT center: centering a scrollable flex row whose content\n     overflows makes its left edge unreachable. */\n  .reviewify-photo-strip { justify-content: flex-start; }\n  .reviewify-write-btn-wrap { justify-content: center; }\n}\n\n/* ── Review card ── */\n.reviewify-card {\n  position: absolute !important;\n  background: #fff;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n  border: 1px solid #f0f0f0;\n  transition: box-shadow 0.2s, transform 0.3s, opacity 0.3s;\n  box-sizing: border-box;\n  opacity: 1;\n}\n.reviewify-card:hover {\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n.reviewify-card-photos {\n  position: relative;\n  margin-bottom: 10px;\n}\n.reviewify-card-photo {\n  width: 100%;\n  /* v5: the width/height attributes are only a ratio hint — without this the\n     photo was as tall as the attribute (350x280 in a 350 px column). */\n  height: auto;\n  aspect-ratio: 1;\n  object-fit: cover;\n  border-radius: 8px;\n  cursor: pointer;\n  background: #f3efe9;\n  color: transparent;\n}\n.reviewify-card-photo-row {\n  display: flex;\n  gap: 4px;\n  margin-top: 4px;\n  align-items: center;\n}\n.reviewify-card-photo-sm {\n  width: 48px;\n  height: 48px;\n  object-fit: cover;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: transform 0.2s;\n  background: #f3efe9;\n  color: transparent;\n}\n.reviewify-card-photo-sm:hover {\n  transform: scale(1.08);\n}\n.reviewify-photo-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background: rgba(0,0,0,0.06);\n  color: #888;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n}\n\n.reviewify-card-stars {\n  margin-bottom: 8px;\n}\n\n.reviewify-card-reviewer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n.reviewify-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1.5px solid #f0ebe5;\n  background: #f3efe9;\n  color: transparent;\n}\n.reviewify-avatar-placeholder {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n  letter-spacing: 0.5px;\n}\n.reviewify-reviewer-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n.reviewify-verified {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  background: #dcfce7;\n  color: #166534;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n  letter-spacing: 0.02em;\n}\n\n.reviewify-card-text {\n  font-size: 13px;\n  line-height: 1.5;\n  color: #555;\n  margin: 0 0 8px;\n}\n.reviewify-read-more {\n  border: none;\n  background: none;\n  color: #888;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 8px;\n  text-decoration: underline;\n  display: block;\n}\n.reviewify-read-more:hover {\n  color: #555;\n}\n.reviewify-card-date {\n  font-size: 11px;\n  color: #aaa;\n  margin-bottom: 8px;\n}\n.reviewify-helpful {\n  border: 1px solid #e0e0e0;\n  background: #fff;\n  color: #888;\n  font-size: 12px;\n  padding: 4px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.reviewify-helpful:hover {\n  background: #f8f8f8;\n  color: #333;\n}\n.reviewify-helpful-active {\n  border-color: #0D9488;\n  background: #0D94881a;\n  color: #0D9488;\n  font-weight: 600;\n}\n\n/* ── Stars ── */\n.reviewify-stars {\n  display: inline-flex;\n  gap: 1px;\n}\n.reviewify-star {\n  width: 16px;\n  height: 16px;\n}\n.reviewify-star-full polygon {\n  fill: #f4c01e;\n}\n.reviewify-star-empty polygon {\n  fill: #e0e0e0;\n}\n.reviewify-star-badge .reviewify-star {\n  width: 14px;\n  height: 14px;\n}\n\n/* ── Lightbox/Modal ── */\n.reviewify-lightbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.25s ease;\n  pointer-events: none;\n}\n.reviewify-lightbox-visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n.reviewify-lightbox-backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.85);\n}\n.reviewify-lightbox-close {\n  position: absolute;\n  top: 16px;\n  right: 20px;\n  z-index: 2;\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 36px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 4px 10px;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n}\n.reviewify-lightbox-close:hover {\n  opacity: 1;\n}\n.reviewify-lightbox-prev,\n.reviewify-lightbox-next {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n  background: rgba(255,255,255,0.15);\n  border: none;\n  color: #fff;\n  font-size: 40px;\n  line-height: 1;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.2s, background 0.2s;\n}\n.reviewify-lightbox-prev:hover,\n.reviewify-lightbox-next:hover {\n  opacity: 1;\n  background: rgba(255,255,255,0.25);\n}\n.reviewify-lightbox-prev {\n  left: 16px;\n}\n.reviewify-lightbox-next {\n  right: 16px;\n}\n.reviewify-lightbox-img-wrap {\n  position: relative;\n  z-index: 1;\n  max-width: 90vw;\n  max-height: 85vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.reviewify-lightbox-img {\n  max-width: 90vw;\n  max-height: 85vh;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 8px 40px rgba(0,0,0,0.5);\n  transition: opacity 0.2s ease;\n}\n.reviewify-lightbox-counter {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  background: rgba(0,0,0,0.5);\n  padding: 4px 14px;\n  border-radius: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n@media (max-width: 600px) {\n  .reviewify-lightbox-prev,\n  .reviewify-lightbox-next {\n    width: 36px;\n    height: 36px;\n    font-size: 28px;\n  }\n  .reviewify-lightbox-prev { left: 8px; }\n  .reviewify-lightbox-next { right: 8px; }\n}\n\n/* ── Show more ── */\n.reviewify-show-more-wrap {\n  text-align: center;\n  margin-top: 24px;\n}\n.reviewify-show-more {\n  background: #333;\n  color: #fff;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.reviewify-show-more:hover {\n  background: #555;\n}\n\n/* ── Write a Review Button ── */\n.reviewify-write-btn-wrap {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding-top: 8px;\n}\n.reviewify-write-btn {\n  background: #2d3748;\n  color: #fff;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 24px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  cursor: pointer;\n  transition: background 0.2s, transform 0.15s;\n  white-space: nowrap;\n}\n.reviewify-write-btn:hover {\n  background: #4a5568;\n  transform: translateY(-1px);\n}\n\n/* ── Write a Review Form ── */\n.reviewify-write-form {\n  margin-top: 16px;\n  padding: 32px 0;\n  border-top: 1px solid #e8e8e8;\n}\n.reviewify-form-inner {\n  max-width: 100%;\n}\n.reviewify-form-row {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 20px;\n}\n.reviewify-form-field {\n  flex: 1;\n  min-width: 0;\n}\n.reviewify-form-full {\n  width: 100%;\n  margin-bottom: 20px;\n}\n.reviewify-form-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n.reviewify-form-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #2d3748;\n  background: #f7fafc;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n.reviewify-form-input:focus {\n  outline: none;\n  border-color: #a0aec0;\n  background: #fff;\n}\n.reviewify-form-textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #2d3748;\n  background: #f7fafc;\n  resize: vertical;\n  min-height: 80px;\n  font-family: inherit;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n.reviewify-form-textarea:focus {\n  outline: none;\n  border-color: #a0aec0;\n  background: #fff;\n}\n.reviewify-form-hint {\n  font-size: 12px;\n  color: #a0aec0;\n  margin-top: 6px;\n}\n.reviewify-form-stars {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n.reviewify-photo-upload-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.reviewify-avatar-preview {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #a0aec0;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.reviewify-upload-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #4a5568;\n  background: #fff;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.reviewify-upload-btn:hover {\n  background: #f7fafc;\n}\n.reviewify-form-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.reviewify-upload-media-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 20px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #4a5568;\n  background: #fff;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.reviewify-upload-media-btn:hover {\n  background: #f7fafc;\n}\n.reviewify-media-preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n}\n.reviewify-submit-btn {\n  background: #e53e3e;\n  color: #fff;\n  border: none;\n  padding: 12px 28px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-left: auto;\n}\n.reviewify-submit-btn:hover {\n  background: #c53030;\n}\n.reviewify-submit-btn:disabled {\n  background: #a0aec0;\n  cursor: not-allowed;\n}\n.reviewify-form-status {\n  margin-top: 12px;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n@media (max-width: 600px) {\n  .reviewify-form-row {\n    flex-direction: column;\n    gap: 16px;\n  }\n  .reviewify-write-btn-wrap {\n    justify-content: center;\n    margin-top: 12px;\n  }\n}\n";
  function rvfyEnsureStyle() {
    if (document.getElementById('reviewify-style')) return;
    var st = document.createElement('style');
    st.id = 'reviewify-style';
    st.textContent = RVFY_CSS;
    (document.head || document.documentElement).appendChild(st);
  }
  rvfyEnsureStyle();

  // ── Saved copy first: stars and reviews render with NO network call ──
  var shownSnap = null;
  var shownCtl = null;
  if (snap && snap.stats.totalReviews > 0) {
    window.__reviewifyLoaded = 1;
    shownSnap = snap;
    renderStarBadge(snap.stats);
    shownCtl = renderReviewsSection(snap.reviews.slice(), snap.stats) || null;
    console.log('[Reviewify] Rendered ' + snap.reviews.length + ' saved review(s) from the store');
  }
  // No saved copy drawn (none printed, refused, or empty): nothing will fill
  // the reserved line now — release it before the first paint. (A later live
  // answer still inserts the badge, as on products without a saved copy.)
  rvfyReleaseBadge();

  // ── Fetch reviews (live check) ──
  // Always asked: openweav.com is the source of truth. A failed, slow or
  // flagged answer leaves the saved copy on the page; a different valid
  // answer replaces it (a review deleted in the app disappears here even
  // before the saved copy is rewritten).
  var reviewsUrl = REVIEWIFY_API + '/reviews?' + STORE_QS + '&productId=' + encodeURIComponent(productId) + WS_QS;
  var fetchOpts;
  var fetchTimer = null;
  if (snap) {
    reviewsUrl += '&v=' + encodeURIComponent(snap.builtAt);
    if (typeof AbortController === 'function') {
      var fetchAbort = new AbortController();
      fetchOpts = { signal: fetchAbort.signal };
      fetchTimer = setTimeout(function() { try { fetchAbort.abort(); } catch (e) {} }, 8000);
    }
  }
  // Without a saved copy the request is made exactly as before 2026-09-24:
  // ONE argument (a storefront's fetch wrapper — analytics / pixel apps — may
  // read a second one even when it is undefined), and any answer's JSON is
  // read as before. With a saved copy, a non-2xx answer keeps it.
  var reviewsReq = fetchOpts ? fetch(reviewsUrl, fetchOpts) : fetch(reviewsUrl);
  reviewsReq
    .then(function(r) {
      if (fetchTimer) clearTimeout(fetchTimer);
      if (snap && !r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function(data) {
      rvfyApplyLive(data);
    })
    .catch(function(err) {
      if (fetchTimer) clearTimeout(fetchTimer);
      // Nothing is removed: the saved copy (when there is one) stays on the page.
      console.warn('[Reviewify] Failed to load reviews:', err);
    });

  function rvfyApplyLive(data) {
      console.log('[Reviewify] API response:', data ? data.stats : 'null');
      // Legacy (hostname-resolved) tags learn their slug from the response —
      // the "Write a review" form POSTs it back to /submit-review.
      if (data && !storeSlug && data.storeSlug) storeSlug = data.storeSlug;
      var decision = rvfyReconcile(shownSnap, data);
      if (decision.action === 'none') {
        console.log('[Reviewify] No reviews found for this product');
        return;
      }
      if (decision.action === 'keep') return;
      if (decision.action === 'render') {
        renderStarBadge(data.stats);
        shownCtl = renderReviewsSection(data.reviews, data.stats) || null;
        return;
      }
      if (decision.action === 'extend') {
        if (shownCtl) shownCtl.extend(decision.extra);
        return;
      }
      // 'rerender' / 'remove': the saved copy is out of date. Never pull the
      // section away from a shopper who is writing a review (a focused sort
      // control is not writing — the in-place rebuild keeps the sort and the
      // focus; review 2026-09-25 r3: that update used to be thrown away).
      if (rvfyUserIsWriting()) return;
      shownSnap = null;
      if (decision.action === 'remove') {
        rvfyRemoveRendered();
        shownCtl = null;
        return;
      }
      // 'rerender' IN PLACE (widget v6, audit finding 21): the badge text is
      // updated where it is and the section is rebuilt in its own slot with
      // the same Show More depth and sort, the reader's scroll anchored to
      // the review they were looking at — a shopper already reading reviews
      // is never thrown to the footer.
      renderStarBadge(data.stats);
      shownCtl = renderReviewsSection(data.reviews, data.stats, { inPlace: true }) || null;
  }

  function rvfyUserIsWriting() {
    var wf = document.getElementById('reviewify-write-form');
    if (wf && wf.style.display !== 'none') return true;
    var active = document.activeElement;
    var sec = document.getElementById('reviewify-reviews');
    return !!(active && sec && sec.contains(active) && /^(INPUT|TEXTAREA)$/.test(active.tagName));
  }

  function rvfyRemoveRendered() {
    var badges = document.querySelectorAll('.reviewify-star-badge');
    for (var bi = 0; bi < badges.length; bi++) {
      if (badges[bi].parentNode) badges[bi].parentNode.removeChild(badges[bi]);
    }
    var oldSection = document.getElementById('reviewify-reviews');
    if (oldSection && oldSection.parentNode) oldSection.parentNode.removeChild(oldSection);
  }

  // ── Render star rating badge near product title ──
  // CRITICAL: Anchored ONLY to native theme elements.
  // DO NOT use <wise-star-rating>, <wise-product-reviews>, or any WiseReviews selectors.
  // When WiseReviews is uninstalled, Reviewify must keep working.
  function renderStarBadge(stats) {
    // Strategy: Find the native product title wrapper (div.product__title)
    // and inject our badge directly AFTER it, BEFORE the price block.
    // This is the Dawn theme's permanent element structure.
    
    // Primary: div.product__title (Dawn theme native wrapper around h1)
    var titleWrapper = document.querySelector('div.product__title');
    
    // Fallback chain for other Shopify themes (all native, no app blocks)
    if (!titleWrapper) {
      titleWrapper = document.querySelector('.product__title');
    }
    if (!titleWrapper) {
      titleWrapper = document.querySelector('h1.product-single__title');
    }
    if (!titleWrapper) {
      // Last resort: find the h1 inside the product info container
      var h1 = document.querySelector('section[class*="product__info"] h1, .product__info-container h1');
      if (h1) titleWrapper = h1.parentElement;
    }
    // Already on the page (the saved copy, or another copy of this script):
    // updated in place — never a second badge, never a remove + insert.
    var existingBadge = document.querySelector('.reviewify-star-badge');
    if (existingBadge) {
      existingBadge.innerHTML = rvfyBadgeHtml(stats);
      rvfyReleaseBadge();
      return;
    }
    if (!titleWrapper) { rvfyReleaseBadge(); return; }

    var badge = document.createElement('div');
    badge.className = 'reviewify-star-badge';
    badge.innerHTML = rvfyBadgeHtml(stats);
    
    // Scroll to reviews section on click
    badge.style.cursor = 'pointer';
    badge.addEventListener('click', function() {
      var section = document.getElementById('reviewify-reviews');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Insert AFTER the title wrapper div (before the price block)
    // The price block is div[id^="price-template"] — a native theme element
    var priceBlock = document.querySelector('div[id^="price-template"]');
    if (priceBlock && priceBlock.parentNode === titleWrapper.parentNode) {
      // Insert right before the price block (after title)
      priceBlock.parentNode.insertBefore(badge, priceBlock);
    } else {
      // Fallback: insert after the title wrapper
      titleWrapper.parentNode.insertBefore(badge, titleWrapper.nextSibling);
    }
    // Same task as the insert: the reserve and the badge swap in one frame.
    rvfyReleaseBadge();
  }

  function rvfyBadgeHtml(stats) {
    return renderStars(stats.averageRating) +
      ' <span class="reviewify-badge-rating">' + stats.averageRating + '</span>' +
      ' <span class="reviewify-badge-count">' + rvfyCountLabel(stats.totalReviews) + '</span>';
  }

  // ── Render full reviews section ──
  // CRITICAL: Anchored ONLY to native theme elements.
  // DO NOT use <wise-product-reviews> or any WiseReviews selectors.
  // Reviews grid is a DIRECT CHILD of <main id="MainContent">, NOT inside ProductInfo.
  // This mirrors WiseReviews which is also a separate <section> child of <main>.
  function renderReviewsSection(reviews, stats, opts) {
    var old = document.getElementById('reviewify-reviews');
    var inPlace = !!(opts && opts.inPlace && old && old.parentNode);
    // Don't inject twice
    if (old && !inPlace) return;

    // MUST insert as a direct child of <main>, not inside any product info container.
    var mainEl = document.getElementById('MainContent') || document.querySelector('main');
    if (!mainEl && !inPlace) return;

    // Find the cross-sell / "You may also like" section to insert BEFORE it
    var crossSell = mainEl ? mainEl.querySelector(':scope > section[id*="related-products"]') : null;
    // insertBefore target: if cross-sell exists, insert before it; otherwise append to end
    var insertBeforeTarget = crossSell || null;

    // Widget v6: the list is always sorted from the UNTOUCHED base order (the
    // server's "Recommended") — never from the previous sort.
    var base = (reviews || []).slice();
    var perPage = 16;
    var sortMode = 'recommended';
    var keepShown = 0;
    var anchor = null;
    var keepOpen = {};
    var sortHadFocus = false;
    var canNewest = rvfyDatedShare(base) >= 0.5;
    if (inPlace) {
      // What the reader had: Show More depth, sort (and its focus), the
      // reviews they opened with "Read more", and the review they were
      // looking at (or, scrolled past the section, the element after it).
      var oldSel = old.querySelector('.reviewify-sort-select');
      if (oldSel && oldSel.value) sortMode = oldSel.value;
      sortHadFocus = !!(oldSel && document.activeElement === oldSel);
      keepShown = old.querySelectorAll('.reviewify-card').length;
      var opened = old.querySelectorAll('.reviewify-read-more[data-expanded="1"]');
      for (var oi = 0; oi < opened.length; oi++) {
        var oc = opened[oi].parentNode;
        while (oc && oc !== old && !(oc.classList && oc.classList.contains('reviewify-card'))) oc = oc.parentNode;
        if (oc && oc !== old && oc.getAttribute('data-rvfy-id') != null) keepOpen[oc.getAttribute('data-rvfy-id')] = 1;
      }
      anchor = rvfyScrollAnchor(old);
    }
    if (sortMode === 'newest' && !canNewest) sortMode = 'recommended';
    if (sortMode !== 'recommended' && sortMode !== 'newest' && sortMode !== 'highest' && sortMode !== 'lowest') sortMode = 'recommended';
    var view = rvfySortReviews(base, sortMode);

    var section = document.createElement('section');
    section.id = 'reviewify-reviews';
    section.className = 'reviewify-section';
    // Inline guard: the section can never widen the page, even unstyled.
    section.style.maxWidth = '100%';
    rvfySets = {};
    rvfyCardImgW = rvfyEstimateCardImgW(mainEl || old.parentNode);

    // Build HTML
    var html = '<div class="reviewify-container">';
    
    // ── Summary header ──
    html += '<div class="reviewify-summary">';
    html += '<div class="reviewify-summary-left">';
    html += '<div class="reviewify-avg-rating">' + stats.averageRating + '</div>';
    html += '<div class="reviewify-avg-stars">' + renderStars(stats.averageRating) + '</div>';
    html += '<div class="reviewify-total-count">' + rvfyCountLabel(stats.totalReviews) + '</div>';
    html += '</div>';
    
    // Rating breakdown bars
    html += '<div class="reviewify-breakdown">';
    for (var star = 5; star >= 1; star--) {
      var count = stats.ratingBreakdown[star] || 0;
      var pct = stats.totalReviews > 0 ? Math.round((count / stats.totalReviews) * 100) : 0;
      html += '<div class="reviewify-breakdown-row">';
      html += '<span class="reviewify-breakdown-stars">' + renderStars(star) + '</span>';
      html += '<div class="reviewify-bar"><div class="reviewify-bar-fill" style="width:' + pct + '%"></div></div>';
      html += '<span class="reviewify-bar-pct">' + pct + '%</span>';
      html += '</div>';
    }
    html += '</div>';
    
    // Photo strip: ONE hero photo per review. Some imported reviews carry
    // several photos each — flattening them all
    // let a single 8-photo review fill the entire strip. Every photo still
    // reaches the lightbox and the review card; the strip is one thumb per
    // review, in review order.
    var allPhotos = [];
    var heroPhotos = [];
    for (var p = 0; p < base.length; p++) {
      var livePhotos = rvfyLive(base[p].buyerPhotos);
      if (livePhotos.length > 0) {
        heroPhotos.push({ src: livePhotos[0], index: allPhotos.length });
        for (var q = 0; q < livePhotos.length; q++) {
          allPhotos.push(livePhotos[q]);
        }
      }
    }
    // The lightbox reads the set from the registry (the full list used to be
    // repeated as JSON on every thumbnail — ~100 KB each on big pages).
    rvfySets.strip = allPhotos;
    if (heroPhotos.length > 0) {
      html += '<div class="reviewify-photo-strip">';
      var maxPhotos = Math.min(heroPhotos.length, 8);
      for (var ph = 0; ph < maxPhotos; ph++) {
        // 64 px box: 1x/2x from the store's own files (128 px at most).
        html += rvfyImgTag(heroPhotos[ph].src, 64, 64, 'crop', 'alt="Review photo" class="reviewify-photo-thumb" width="64" height="64" style="width:64px;height:64px;max-width:64px;object-fit:cover;flex:0 0 auto" data-rvfy-set="strip" data-rvfy-index="' + heroPhotos[ph].index + '" loading="lazy" decoding="async"');
      }
      html += '</div>';
    }
    
    // ── Write a Review button (right side of summary) ──
    html += '<div class="reviewify-write-btn-wrap">';
    html += '<button class="reviewify-write-btn" id="reviewify-write-toggle">WRITE A REVIEW</button>';
    html += '</div>';
    html += '</div>'; // end summary

    // ── Write a Review Form (hidden by default) ──
    html += '<div id="reviewify-write-form" class="reviewify-write-form" style="display:none">';
    html += '<div class="reviewify-form-inner">';
    
    // Row 1: Name + Email
    html += '<div class="reviewify-form-row">';
    html += '<div class="reviewify-form-field">';
    html += '<label class="reviewify-form-label">Name*</label>';
    html += '<input type="text" id="reviewify-name" class="reviewify-form-input" placeholder="Enter your name" required />';
    html += '</div>';
    html += '<div class="reviewify-form-field">';
    html += '<label class="reviewify-form-label">Email*</label>';
    html += '<input type="email" id="reviewify-email" class="reviewify-form-input" placeholder="Enter your email address" required />';
    html += '</div>';
    html += '</div>';
    
    // Row 2: Rating + Reviewer Photo
    html += '<div class="reviewify-form-row">';
    html += '<div class="reviewify-form-field">';
    html += '<label class="reviewify-form-label">Rating*</label>';
    html += '<div class="reviewify-form-stars" id="reviewify-rating-stars">';
    for (var rs = 1; rs <= 5; rs++) {
      html += '<svg class="reviewify-form-star" data-rating="' + rs + '" viewBox="0 0 20 20" style="cursor:pointer;width:24px;height:24px"><polygon points="10,1 12.5,7.5 19.5,7.5 14,12 16,19 10,15 4,19 6,12 0.5,7.5 7.5,7.5" fill="#f4c01e"/></svg>';
    }
    html += '</div>';
    html += '<input type="hidden" id="reviewify-rating" value="5" />';
    html += '</div>';
    html += '<div class="reviewify-form-field">';
    html += '<label class="reviewify-form-label">Reviewer Photo (Optional)</label>';
    html += '<div class="reviewify-photo-upload-row">';
    html += '<div class="reviewify-avatar-preview" id="reviewify-avatar-preview"><span id="reviewify-avatar-initial">?</span></div>';
    html += '<label class="reviewify-upload-btn" for="reviewify-avatar-input">Upload Photo &#9729;</label>';
    html += '<input type="file" id="reviewify-avatar-input" accept="image/*" style="display:none" />';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    
    // Row 3: Review Body
    html += '<div class="reviewify-form-field reviewify-form-full">';
    html += '<label class="reviewify-form-label">Review Body*</label>';
    html += '<textarea id="reviewify-body" class="reviewify-form-textarea" placeholder="Write your comment..." rows="3"></textarea>';
    html += '<div class="reviewify-form-hint">*indicates required field</div>';
    html += '</div>';
    
    // Row 4: Upload Media + Submit
    html += '<div class="reviewify-form-actions">';
    html += '<label class="reviewify-upload-media-btn" for="reviewify-media-input">Upload Media &#9729;</label>';
    html += '<input type="file" id="reviewify-media-input" accept="image/*" multiple style="display:none" />';
    html += '<div id="reviewify-media-preview" class="reviewify-media-preview"></div>';
    html += '<button type="button" id="reviewify-submit-btn" class="reviewify-submit-btn">Submit Review</button>';
    html += '</div>';
    
    // Status message
    html += '<div id="reviewify-form-status" class="reviewify-form-status" style="display:none"></div>';
    
    html += '</div>'; // end form-inner
    html += '</div>'; // end write-form

    // (Widget v6: the product/shop tab row is gone — its second tab never
    // did anything, audit finding 18.)

    // ── Sort ──
    // "Latest first" only when most reviews carry a date it can sort by.
    html += '<div class="reviewify-sort">';
    html += '<span>Sort by</span>';
    html += '<select class="reviewify-sort-select">';
    var sortOpts = [['recommended', 'Recommended'], ['newest', 'Latest first'], ['highest', 'Highest rating'], ['lowest', 'Lowest rating']];
    for (var so = 0; so < sortOpts.length; so++) {
      if (sortOpts[so][0] === 'newest' && !canNewest) continue;
      html += '<option value="' + sortOpts[so][0] + '"' + (sortOpts[so][0] === sortMode ? ' selected' : '') + '>' + sortOpts[so][1] + '</option>';
    }
    html += '</select>';
    html += '</div>';

    // ── Reviews grid ──
    // One column (phones): normal flow from the start — no absolute placing.
    var flow = rvfyColsFor(Math.max(1, Math.min((mainEl || old.parentNode).clientWidth || window.innerWidth || 1200, 1200) - 40)) === 1;
    html += '<div class="reviewify-grid' + (flow ? ' reviewify-grid-flow" data-rvfy-cols="1"' : '"') + '>';
    var showing = Math.min(view.length, keepShown > perPage ? Math.ceil(keepShown / perPage) * perPage : perPage);
    // A review the reader could see is never pushed past the kept depth (a
    // new review ranked above it): the list grows to the page that holds it.
    var anchorAt = rvfyAnchorIndex(anchor, view);
    if (anchorAt >= 0) showing = Math.min(view.length, Math.max(showing, Math.ceil((anchorAt + 1) / perPage) * perPage));
    for (var i = 0; i < showing; i++) {
      html += renderReviewCard(view[i]);
    }
    html += '</div>';

    // ── Show more button ──
    if (view.length > showing) {
      html += '<div class="reviewify-show-more-wrap">';
      html += '<button class="reviewify-show-more" data-page="' + (showing / perPage - 1) + '" data-total="' + view.length + '">Show More</button>';
      html += '</div>';
    }

    html += '</div>'; // end container
    section.innerHTML = html;

    if (inPlace) {
      // Same slot, same task: the old section is swapped for the new one and
      // the scroll is corrected before the browser paints. Reviews the reader
      // opened stay open (before the layout and the anchor measure them), and
      // a focused sort control hands its focus to the new one.
      rvfyReopenCards(section, keepOpen);
      old.parentNode.replaceChild(section, old);
      if (sortHadFocus) {
        var newSel = section.querySelector('.reviewify-sort-select');
        try { if (newSel) newSel.focus({ preventScroll: true }); } catch (e) { /* focus is a nicety */ }
      }
    } else if (insertBeforeTarget) {
      // Insert as a DIRECT CHILD of <main>, BEFORE the cross-sell / "You may also like" section.
      // This ensures reviews appear above product recommendations.
      mainEl.insertBefore(section, insertBeforeTarget);
    } else {
      mainEl.appendChild(section);
    }
    console.log('[Reviewify] Reviews section ' + (inPlace ? 'updated in place' : 'injected as direct child of <main>, before: ' + (insertBeforeTarget ? insertBeforeTarget.id || insertBeforeTarget.tagName : 'end of main')));

    // ── Masonry layout engine ──
    // Widget v5: STABLE. A card keeps the column it was placed in
    // (data-rvfy-col) and only the tops are recomputed, so a relayout after an
    // image error / load / "Read more" never reshuffles the grid; cards
    // without a column (first layout, Show More, a new sort) go to the
    // shortest column in order — exactly the old placement. A change of the
    // column count re-places every card.
    // Widget v6: one column (phones) = normal flow (the cards stack by
    // themselves; a photo or "Read more" needs no relayout, nothing is placed
    // absolutely); several columns = writes (widths), then reads (heights),
    // then writes (positions) — one layout per pass, never per card.
    function layoutMasonry() {
      var grid = section.querySelector('.reviewify-grid');
      if (!grid) return;
      var cards = grid.querySelectorAll('.reviewify-card');
      var w = grid.offsetWidth;
      if (w <= 0) return; // not visible yet
      var cols = rvfyColsFor(w);
      var ci;
      if (cols === 1) {
        if (grid.getAttribute('data-rvfy-cols') !== '1' || !grid.classList.contains('reviewify-grid-flow')) {
          grid.setAttribute('data-rvfy-cols', '1');
          grid.classList.add('reviewify-grid-flow');
          grid.style.height = '';
          for (ci = 0; ci < cards.length; ci++) {
            cards[ci].style.width = '';
            cards[ci].style.left = '';
            cards[ci].style.top = '';
            cards[ci].removeAttribute('data-rvfy-col');
          }
        }
        rvfyUpsizeCardPhotos(grid);
        return;
      }
      if (cards.length === 0) { grid.style.height = '0px'; return; }
      var gap = 16;
      var colW = (w - gap * (cols - 1)) / cols;
      var reshuffle = grid.getAttribute('data-rvfy-cols') !== String(cols);
      grid.setAttribute('data-rvfy-cols', String(cols));
      grid.classList.remove('reviewify-grid-flow');
      // Writes: widths first so every height below is measured at its width.
      for (ci = 0; ci < cards.length; ci++) cards[ci].style.width = colW + 'px';
      // Reads: all heights in one layout.
      var heights = [];
      for (ci = 0; ci < cards.length; ci++) heights.push(cards[ci].offsetHeight);
      // Writes: positions. A card keeps the column it was placed in
      // (data-rvfy-col) — a relayout never reshuffles the grid; new cards go
      // to the shortest column in order; a change of column count re-places all.
      var colH = [];
      for (var c = 0; c < cols; c++) colH.push(0);
      for (ci = 0; ci < cards.length; ci++) {
        var card = cards[ci];
        var col = reshuffle ? -1 : parseInt(card.getAttribute('data-rvfy-col'), 10);
        if (!(col >= 0 && col < cols)) {
          col = 0;
          for (var mc = 1; mc < cols; mc++) {
            if (colH[mc] < colH[col]) col = mc;
          }
          card.setAttribute('data-rvfy-col', String(col));
        }
        card.style.left = (col * (colW + gap)) + 'px';
        card.style.top = colH[col] + 'px';
        colH[col] += heights[ci] + gap;
      }
      var maxH = 0;
      for (var mh = 0; mh < colH.length; mh++) { if (colH[mh] > maxH) maxH = colH[mh]; }
      grid.style.height = maxH + 'px';
      rvfyUpsizeCardPhotos(grid);
    }
    // The real card photo width is known now: requests only ever grow (a
    // larger bucket), never shrink — and this runs before the browser's lazy
    // loader looks at the images, so nothing is fetched twice.
    function rvfyUpsizeCardPhotos(grid) {
      var first = grid.querySelector('.reviewify-card-photo');
      if (!first) return;
      var real = first.getBoundingClientRect ? first.getBoundingClientRect().width : 0;
      if (!(real > 0) || rvfyBucket(real) <= rvfyBucket(rvfyCardImgW)) return;
      rvfyCardImgW = real;
      var heroes = grid.querySelectorAll('.reviewify-card-photo');
      for (var hi = 0; hi < heroes.length; hi++) {
        var base = heroes[hi].getAttribute('data-rvfy-u');
        if (base) rvfySetImg(heroes[hi], base, real, real, 'crop');
      }
    }
    var rvfyRelayoutTimer = null;
    function rvfyRelayoutSoon() {
      if (rvfyRelayoutTimer) clearTimeout(rvfyRelayoutTimer);
      rvfyRelayoutTimer = setTimeout(function() { rvfyRelayoutTimer = null; layoutMasonry(); }, 50);
    }
    // At most one relayout per frame (image loads come in bursts).
    var rvfyFrame = 0;
    function rvfyRelayoutFrame() {
      if (rvfyFrame) return;
      var raf = window.requestAnimationFrame || function(f) { return setTimeout(f, 16); };
      rvfyFrame = raf(function() { rvfyFrame = 0; layoutMasonry(); }) || 1;
    }
    // Synchronously, right after insertion: cards are placed (and lazy
    // images see their real position) before anything is fetched; one
    // re-run in the next frame (before it is painted) — no timers.
    layoutMasonry();
    rvfyRelayoutFrame();
    rvfyActiveLayout = layoutMasonry;
    rvfyBindResize();
    // In place: the reader stays on the review they were looking at.
    if (anchor) rvfyRestoreAnchor(section, anchor);
    // Re-layout when any image in the grid finishes loading (stable). A photo
    // that loaded anywhere is not broken (a flaky request elsewhere marked it)
    // and — having been seen — is never marked broken on this page again.
    // A card photo that just LOADED a promoted photo drops that photo's small
    // thumbnail only now (until then the thumbnail keeps showing it).
    section.addEventListener('load', function(e) {
      var t = e.target;
      if (t && t.tagName === 'IMG') {
        rvfyNoteLoaded(t);
        var promo = t.getAttribute ? t.getAttribute('data-rvfy-promote') : null;
        if (promo && promo === t.getAttribute('data-rvfy-u') && t.naturalWidth > 0) {
          t.removeAttribute('data-rvfy-promote');
          var pblock = rvfyClosest(t, 'reviewify-card-photos');
          var psm = pblock ? pblock.querySelectorAll('.reviewify-card-photo-sm') : [];
          for (var pi = 0; pi < psm.length; pi++) {
            if (psm[pi].getAttribute('data-rvfy-u') === promo && psm[pi].parentNode) psm[pi].parentNode.removeChild(psm[pi]);
          }
          var prow = pblock ? pblock.querySelector('.reviewify-card-photo-row') : null;
          if (prow && !prow.querySelector('img') && prow.parentNode) prow.parentNode.removeChild(prow);
        }
        rvfyRelayoutFrame();
      }
    }, true);
    // No broken image, ever: a failed photo tries its fallback address once,
    // then is dropped from THIS element — the next photo takes the card's
    // place, a thumbnail disappears, an avatar becomes the reviewer's
    // initials. The photo is marked broken for the page only when it never
    // loaded here and no other element shows it (rvfyMarkBroken). A card
    // photo never tries the same photo twice (its own budget): photos that
    // load elsewhere but fail at the card size can never cycle.
    section.addEventListener('error', function(e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG' || !img.hasAttribute || !img.hasAttribute('data-rvfy-u')) return;
      if (rvfyTryFallback(img)) return;
      var base = img.getAttribute('data-rvfy-u');
      rvfyMarkBroken(base, img);
      var cl = img.classList;
      if (cl.contains('reviewify-card-photo')) {
        var block = rvfyClosest(img, 'reviewify-card-photos');
        var tried = img._rvfyTried || (img._rvfyTried = {});
        tried[base] = 1;
        img.removeAttribute('data-rvfy-promote');
        var live = [];
        var liveAll = rvfyLive(rvfySets[img.getAttribute('data-rvfy-set')]);
        for (var lv = 0; lv < liveAll.length; lv++) { if (!rvfyHas(tried, liveAll[lv])) live.push(liveAll[lv]); }
        if (!live.length) {
          // Nothing left to try here: the card photo goes (small thumbnails that show stay).
          if (img.parentNode) img.parentNode.removeChild(img);
          if (block && !block.querySelector('img') && block.parentNode) block.parentNode.removeChild(block);
        } else {
          var set = rvfySets[img.getAttribute('data-rvfy-set')] || [];
          img.setAttribute('data-rvfy-index', String(set.indexOf(live[0])));
          img.setAttribute('data-rvfy-promote', live[0]);
          rvfySetImg(img, live[0], rvfyCardImgW || img.clientWidth || 280, rvfyCardImgW || img.clientWidth || 280, 'crop');
        }
      } else if (cl.contains('reviewify-card-photo-sm') || cl.contains('reviewify-photo-thumb')) {
        var holder = img.parentNode;
        var hblock = holder ? rvfyClosest(holder, 'reviewify-card-photos') : null;
        if (holder) holder.removeChild(img);
        if (holder && !holder.querySelector('img') && holder.parentNode) holder.parentNode.removeChild(holder);
        if (hblock && !hblock.querySelector('img') && hblock.parentNode) hblock.parentNode.removeChild(hblock);
      } else if (cl.contains('reviewify-avatar')) {
        var card = rvfyClosest(img, 'reviewify-card');
        var nameEl = card ? card.querySelector('.reviewify-reviewer-name') : null;
        var tmp = document.createElement('div');
        tmp.innerHTML = rvfyAvatarPlaceholder(nameEl ? nameEl.textContent : '');
        if (img.parentNode && tmp.firstChild) img.parentNode.replaceChild(tmp.firstChild, img);
      }
      rvfyRelayoutSoon();
    }, true);
    // Window resize: ONE listener per page (rvfyBindResize) re-lays out the
    // CURRENT section — a rebuilt section no longer leaks a listener.

    // ── Event listeners ──
    // Show more — extracted as named function for reuse after sort
    function showMoreHandler() {
      var btn = this;
      var page = parseInt(btn.getAttribute('data-page')) + 1;
      var grid = section.querySelector('.reviewify-grid');
      var start = page * perPage;
      var end = Math.min(start + perPage, view.length);
      for (var j = start; j < end; j++) {
        var div = document.createElement('div');
        div.innerHTML = renderReviewCard(view[j]);
        grid.appendChild(div.firstChild);
      }
      btn.setAttribute('data-page', String(page));
      if (end >= view.length) {
        btn.parentNode.removeChild(btn);
      }
      // Placed at once (the lazy loader must see the real positions).
      layoutMasonry();
    }
    var showMoreBtn = section.querySelector('.reviewify-show-more');
    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', showMoreHandler);
    }

    // Lightbox click delegation — attach to the section so dynamically added cards work
    section.addEventListener('click', function(e) {
      var target = e.target;
      if (target.tagName === 'IMG' && target.hasAttribute('data-rvfy-set')) {
        rvfyOpenFrom(target);
      }
      // Read more / Show less toggle
      if (target.classList && target.classList.contains('reviewify-read-more')) {
        var textEl = target.previousElementSibling;
        if (!textEl || !textEl.classList.contains('reviewify-card-text')) return;
        var expanded = target.getAttribute('data-expanded') === '1';
        if (expanded) {
          textEl.textContent = textEl.getAttribute('data-short');
          target.textContent = 'Read more';
          target.setAttribute('data-expanded', '0');
        } else {
          textEl.textContent = textEl.getAttribute('data-full');
          target.textContent = 'Show less';
          target.setAttribute('data-expanded', '1');
        }
        layoutMasonry();
      }
      // Helpful toggle — persists per-visitor in localStorage (no server count).
      if (target.classList && target.classList.contains('reviewify-helpful')) {
        var rid = target.getAttribute('data-rvfy-helpful');
        if (rid) {
          var key = 'reviewify_helpful_' + rid;
          var isActive = false;
          try { isActive = window.localStorage.getItem(key) === '1'; } catch (e) {}
          try {
            if (isActive) { window.localStorage.removeItem(key); }
            else { window.localStorage.setItem(key, '1'); }
          } catch (e) {}
          var nowActive = !isActive;
          target.classList.toggle('reviewify-helpful-active', nowActive);
          target.setAttribute('aria-pressed', nowActive ? 'true' : 'false');
          target.textContent = nowActive ? '✓ Helpful' : 'Helpful';
        }
      }
    });

    // ── Write a Review form event listeners ──
    var writeToggle = document.getElementById('reviewify-write-toggle');
    var writeForm = document.getElementById('reviewify-write-form');
    if (writeToggle && writeForm) {
      writeToggle.addEventListener('click', function() {
        if (writeForm.style.display === 'none') {
          writeForm.style.display = 'block';
          writeToggle.textContent = 'CANCEL';
        } else {
          writeForm.style.display = 'none';
          writeToggle.textContent = 'WRITE A REVIEW';
        }
      });
    }

    // Rating stars interaction
    var ratingStars = section.querySelectorAll('.reviewify-form-star');
    var ratingInput = document.getElementById('reviewify-rating');
    var currentRating = 5;
    function updateFormStars(rating) {
      currentRating = rating;
      if (ratingInput) ratingInput.value = String(rating);
      for (var si = 0; si < ratingStars.length; si++) {
        var starVal = parseInt(ratingStars[si].getAttribute('data-rating'));
        var poly = ratingStars[si].querySelector('polygon');
        if (poly) poly.setAttribute('fill', starVal <= rating ? '#f4c01e' : '#e0e0e0');
      }
    }
    for (var si = 0; si < ratingStars.length; si++) {
      ratingStars[si].addEventListener('click', function() {
        updateFormStars(parseInt(this.getAttribute('data-rating')));
      });
    }

    // Avatar upload preview
    var avatarInput = document.getElementById('reviewify-avatar-input');
    var avatarPreview = document.getElementById('reviewify-avatar-preview');
    var avatarFile = null;
    if (avatarInput) {
      avatarInput.addEventListener('change', function() {
        if (this.files && this.files[0]) {
          avatarFile = this.files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            avatarPreview.innerHTML = '<img src="' + e.target.result + '" style="width:100%;height:100%;object-fit:cover;border-radius:50%" />';
          };
          reader.readAsDataURL(this.files[0]);
        }
      });
    }

    // Name field updates avatar initial
    var nameInput = document.getElementById('reviewify-name');
    var avatarInitial = document.getElementById('reviewify-avatar-initial');
    if (nameInput && avatarInitial) {
      nameInput.addEventListener('input', function() {
        if (!avatarFile && avatarPreview) {
          var val = this.value.trim();
          avatarInitial.textContent = val ? val.charAt(0).toUpperCase() : '?';
        }
      });
    }

    // Media upload preview
    var mediaInput = document.getElementById('reviewify-media-input');
    var mediaPreview = document.getElementById('reviewify-media-preview');
    var mediaFiles = [];
    var RVFY_UNSUPPORTED_PHOTO = "This photo format isn't supported \u2014 please choose a JPG or PNG photo.";
    if (mediaInput) {
      mediaInput.addEventListener('change', function() {
        if (this.files) {
          var refused = false;
          for (var fi = 0; fi < this.files.length; fi++) {
            var pf = this.files[fi];
            // HEIC / HEIF / AVIF are refused at once (the server refuses them too).
            if (/heic|heif|avif/i.test(pf.type || '') || /\.(heic|heif|avif)$/i.test(pf.name || '')) { refused = true; continue; }
            mediaFiles.push(pf);
          }
          if (refused) showFormStatus(RVFY_UNSUPPORTED_PHOTO, 'error');
          renderMediaPreviews();
        }
      });
    }
    // A picked file this browser cannot draw is dropped with a short note —
    // never a broken-image icon in the form, never an upload that disappears.
    function dropMediaFile(file) {
      var at = mediaFiles.indexOf(file);
      if (at < 0) return;
      mediaFiles.splice(at, 1);
      showFormStatus(RVFY_UNSUPPORTED_PHOTO, 'error');
      renderMediaPreviews();
    }
    function renderMediaPreviews() {
      if (!mediaPreview) return;
      mediaPreview.innerHTML = '';
      for (var mi = 0; mi < mediaFiles.length; mi++) {
        (function(idx, file) {
          var reader = new FileReader();
          reader.onload = function(e) {
            if (mediaFiles[idx] !== file) return;
            var wrap = document.createElement('div');
            wrap.style.cssText = 'position:relative;display:inline-block;margin:4px';
            var pimg = document.createElement('img');
            pimg.style.cssText = 'width:60px;height:60px;object-fit:cover;border-radius:8px;border:1px solid #e0e0e0';
            pimg.onerror = function() { dropMediaFile(file); };
            pimg.src = e.target.result;
            wrap.appendChild(pimg);
            wrap.insertAdjacentHTML('beforeend', '<button style="position:absolute;top:-6px;right:-6px;width:18px;height:18px;border-radius:50%;background:#333;color:#fff;border:none;font-size:11px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1" data-remove-media="' + idx + '">&times;</button>');
            mediaPreview.appendChild(wrap);
          };
          reader.onerror = function() { dropMediaFile(file); };
          reader.readAsDataURL(file);
        })(mi, mediaFiles[mi]);
      }
    }
    if (mediaPreview) {
      mediaPreview.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-remove-media]');
        if (btn) {
          var idx = parseInt(btn.getAttribute('data-remove-media'));
          mediaFiles.splice(idx, 1);
          renderMediaPreviews();
        }
      });
    }

    // Submit review
    var submitBtn = document.getElementById('reviewify-submit-btn');
    var formStatus = document.getElementById('reviewify-form-status');
    if (submitBtn) {
      submitBtn.addEventListener('click', function() {
        var name = (document.getElementById('reviewify-name') || {}).value || '';
        var email = (document.getElementById('reviewify-email') || {}).value || '';
        var body = (document.getElementById('reviewify-body') || {}).value || '';
        var rating = parseInt((document.getElementById('reviewify-rating') || {}).value) || 5;

        // Validation
        if (!name.trim()) { showFormStatus('Please enter your name', 'error'); return; }
        if (!email.trim() || email.indexOf('@') < 0) { showFormStatus('Please enter a valid email', 'error'); return; }
        if (!body.trim()) { showFormStatus('Please write your review', 'error'); return; }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';

        // Build FormData for file uploads
        var fd = new FormData();
        fd.append('storeSlug', storeSlug);
        if (workspaceId) fd.append('ws', String(workspaceId));
        fd.append('shopifyProductId', productId);
        fd.append('reviewerName', name.trim());
        fd.append('reviewerEmail', email.trim());
        fd.append('rating', String(rating));
        fd.append('reviewText', body.trim());
        if (avatarFile) fd.append('reviewerPhoto', avatarFile);
        for (var mf = 0; mf < mediaFiles.length; mf++) {
          fd.append('media', mediaFiles[mf]);
        }

        fetch(REVIEWIFY_API + '/submit-review', {
          method: 'POST',
          body: fd
        })
        .then(function(r) { return r.json(); })
        .then(function(res) {
          if (res.success) {
            showFormStatus('Thank you! Your review has been submitted and is pending approval.', 'success');
            // Reset form
            if (document.getElementById('reviewify-name')) document.getElementById('reviewify-name').value = '';
            if (document.getElementById('reviewify-email')) document.getElementById('reviewify-email').value = '';
            if (document.getElementById('reviewify-body')) document.getElementById('reviewify-body').value = '';
            updateFormStars(5);
            avatarFile = null;
            mediaFiles = [];
            if (avatarPreview) avatarPreview.innerHTML = '<span id="reviewify-avatar-initial">?</span>';
            if (mediaPreview) mediaPreview.innerHTML = '';
            // Collapse form after 3s
            setTimeout(function() {
              if (writeForm) writeForm.style.display = 'none';
              if (writeToggle) writeToggle.textContent = 'WRITE A REVIEW';
            }, 3000);
          } else {
            showFormStatus(res.message || 'Failed to submit review. Please try again.', 'error');
          }
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Review';
        })
        .catch(function(err) {
          showFormStatus('Network error. Please try again.', 'error');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Review';
        });
      });
    }

    function showFormStatus(msg, type) {
      if (!formStatus) return;
      formStatus.style.display = 'block';
      formStatus.textContent = msg;
      formStatus.style.color = type === 'error' ? '#dc2626' : '#059669';
      formStatus.style.backgroundColor = type === 'error' ? '#fef2f2' : '#f0fdf4';
      formStatus.style.border = '1px solid ' + (type === 'error' ? '#fecaca' : '#bbf7d0');
      if (type === 'success') {
        setTimeout(function() { formStatus.style.display = 'none'; }, 5000);
      }
    }

    // Rebuild the grid from the current view with "count" cards (sort change).
    function rebuildGrid(count) {
      var grid = section.querySelector('.reviewify-grid');
      var n = Math.min(view.length, Math.max(perPage, count));
      var gh = '';
      for (var k = 0; k < n; k++) gh += renderReviewCard(view[k]);
      grid.innerHTML = gh;
      // Reset or re-create show more button
      var wrap = section.querySelector('.reviewify-show-more-wrap');
      if (view.length > n) {
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.className = 'reviewify-show-more-wrap';
          section.querySelector('.reviewify-container').appendChild(wrap);
        }
        wrap.innerHTML = '<button class="reviewify-show-more" data-page="' + (Math.ceil(n / perPage) - 1) + '" data-total="' + view.length + '">Show More</button>';
        wrap.querySelector('.reviewify-show-more').addEventListener('click', showMoreHandler);
      } else if (wrap) {
        wrap.parentNode.removeChild(wrap);
      }
      // Placed at once: a rebuilt card must never sit in the grid's corner,
      // in view, where the lazy loader would fetch all of their photos.
      grid.removeAttribute('data-rvfy-cols');
      if (grid.classList.contains('reviewify-grid-flow')) grid.setAttribute('data-rvfy-cols', '1');
      layoutMasonry();
    }

    // Sort — always from the untouched base order (widget v6): "Recommended"
    // after "Lowest rating" is the server's order again.
    var sortSelect = section.querySelector('.reviewify-sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        sortMode = this.value;
        view = rvfySortReviews(base, sortMode);
        rebuildGrid(perPage);
      });
    }

    // The saved copy is size-capped: when the live answer carries MORE reviews
    // with the same beginning, they are appended to what the pager can reach —
    // nothing already on screen moves.
    return {
      extend: function(extra) {
        if (!extra || !extra.length) return;
        for (var ex = 0; ex < extra.length; ex++) base.push(extra[ex]);
        var extGrid = section.querySelector('.reviewify-grid');
        if (!extGrid) return;
        var shownCount = extGrid.querySelectorAll('.reviewify-card').length;
        if (sortMode !== 'recommended') {
          // Sorted by the shopper: the longer list is sorted again from the base.
          view = rvfySortReviews(base, sortMode);
          rebuildGrid(Math.ceil(Math.max(shownCount, 1) / perPage) * perPage);
          return;
        }
        for (var ev = 0; ev < extra.length; ev++) view.push(extra[ev]);
        // Top up a partly filled page so the pager stays on page boundaries.
        var target = Math.min(view.length, Math.max(perPage, Math.ceil(shownCount / perPage) * perPage));
        for (var tu = shownCount; tu < target; tu++) {
          var holder = document.createElement('div');
          holder.innerHTML = renderReviewCard(view[tu]);
          extGrid.appendChild(holder.firstChild);
        }
        shownCount = Math.max(shownCount, target);
        if (view.length > shownCount) {
          var extWrap = section.querySelector('.reviewify-show-more-wrap');
          if (!extWrap) {
            extWrap = document.createElement('div');
            extWrap.className = 'reviewify-show-more-wrap';
            section.querySelector('.reviewify-container').appendChild(extWrap);
          }
          var moreBtn = extWrap.querySelector('.reviewify-show-more');
          if (!moreBtn) {
            extWrap.innerHTML = '<button class="reviewify-show-more" data-page="0" data-total="' + view.length + '">Show More</button>';
            moreBtn = extWrap.querySelector('.reviewify-show-more');
            moreBtn.addEventListener('click', showMoreHandler);
          }
          moreBtn.setAttribute('data-page', String(Math.max(0, shownCount / perPage - 1)));
          moreBtn.setAttribute('data-total', String(view.length));
        }
        layoutMasonry();
      }
    };
  }

  // ── Scroll anchor for an in-place update (widget v6) ──
  // What holds the reader's view, recorded before the rebuild (like the
  // browser's own scroll anchoring):
  //  - the TOP OF THE SECTION when it is on screen, or when the first
  //    review starts below the reading line / no card reaches the upper third
  //    of the screen (the reader looks at the summary / the sort row, e.g.
  //    right after tapping the star badge) — the summary stays put and new,
  //    removed or re-ranked reviews change the list BELOW it;
  //  - otherwise the card that crosses a reading line near the top of the
  //    screen (min(120 px, 20 % of the screen) — a card cut off above counts),
  //    else the on-screen card closest to that line. A card that merely
  //    starts low on screen never outranks the card covering the screen.
  // Every card on screen (+ 3 after the last one) is recorded with its offset
  // and whether it was seen: the Show More depth grows to cover every seen
  // card; a card never on screen is only ever used to take the place of a
  // deleted anchor, never put back at its own off-screen offset.
  // Review 2026-09-25 r4: the top-most card STARTING on screen was the
  // anchor — after a badge tap the peeking first review (or, deleted, an
  // off-screen one) was held and the page jumped 528 … 6,580 px.
  // Scrolled past the section: the element after it. A section still below
  // the screen needs no anchor.
  function rvfyScrollAnchor(sec) {
    try {
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      var sr = sec.getBoundingClientRect();
      if (sr.top >= vh) return null;
      if (sr.bottom <= 0) {
        var next = sec.nextElementSibling;
        return next ? { el: next, top: next.getBoundingClientRect().top, secTop: sr.top } : { el: null, top: sr.bottom, after: true, secTop: sr.top };
      }
      var cards = sec.querySelectorAll('.reviewify-card[data-rvfy-id]');
      // Reads only (one layout): every card's box, in the list's order.
      var recs = [];
      var firstSeen = -1, lastSeen = -1, minTop = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        var seen = r.height > 0 && r.bottom > 0 && r.top < vh;
        recs.push({ id: cards[i].getAttribute('data-rvfy-id'), top: r.top, bottom: r.bottom, h: r.height, seen: seen });
        if (seen) {
          if (firstSeen < 0) firstSeen = i;
          lastSeen = i;
          if (r.top < minTop) minTop = r.top;
        }
      }
      var cands = [];
      if (firstSeen >= 0) {
        for (var k = firstSeen; k < recs.length && k <= lastSeen + 3; k++) {
          if (recs[k].h > 0) cands.push({ id: recs[k].id, top: recs[k].top, bottom: recs[k].bottom, seen: recs[k].seen });
        }
      }
      var a = { cands: cands, secTop: sr.top, primary: -1 };
      var line = Math.min(120, vh * 0.2);
      // The summary / the top of the section holds the view: the section
      // starts on screen, no card is on screen, or the reviews start below
      // the reading line (the summary / sort row crosses it) or in the lower
      // two thirds of the screen.
      if (sr.top >= 0 || firstSeen < 0 || minTop >= vh / 3 || (firstSeen === 0 && minTop > line)) return a;
      var bestKey = Infinity;
      for (var q = 0; q < cands.length; q++) {
        var c = cands[q];
        if (!c.seen) continue;
        var key = c.top <= line && c.bottom > line ? 0 : 1 + (c.top > line ? c.top - line : line - c.bottom);
        if (key < bestKey) { bestKey = key; a.primary = q; }
      }
      return a;
    } catch (e) { return null; }
  }

  // The last index in the new view of a card that was ON SCREEN (-1: none of
  // them is left) — renderReviewsSection raises the Show More depth to cover
  // it, so no card the reader could see is pushed past it.
  function rvfyAnchorIndex(a, view) {
    if (!a || !a.cands || !a.cands.length) return -1;
    var seen = {};
    for (var c = 0; c < a.cands.length; c++) if (a.cands[c].seen) seen[a.cands[c].id] = 1;
    var at = -1;
    for (var i = 0; i < view.length; i++) {
      if (view[i] && view[i].id != null && rvfyHas(seen, String(view[i].id))) at = i;
    }
    return at;
  }

  // Cards the reader opened with "Read more" (ids) are drawn open again.
  function rvfyReopenCards(sec, ids) {
    var cards = sec.querySelectorAll('.reviewify-card[data-rvfy-id]');
    for (var i = 0; i < cards.length; i++) {
      if (!rvfyHas(ids, cards[i].getAttribute('data-rvfy-id'))) continue;
      var btn = cards[i].querySelector('.reviewify-read-more');
      var textEl = btn ? btn.previousElementSibling : null;
      if (!btn || !textEl || !textEl.classList.contains('reviewify-card-text') || textEl.getAttribute('data-full') == null) continue;
      textEl.textContent = textEl.getAttribute('data-full');
      btn.textContent = 'Show less';
      btn.setAttribute('data-expanded', '1');
    }
  }

  // A scroll correction is always INSTANT, whatever the theme sets: a root
  // html{scroll-behavior:smooth} (common on legacy / partner themes) turned
  // it into an animation — the reviews jumped ~850 px and slid back, and the
  // hold read its own animation as the shopper scrolling (review 2026-09-25
  // r3). The theme's inline value is put back as it was.
  function rvfyScrollByInstant(dy) {
    if (!dy) return;
    var root = document.documentElement;
    var st = root && root.style;
    var prev = st ? st.getPropertyValue('scroll-behavior') : '';
    var prio = st ? st.getPropertyPriority('scroll-behavior') : '';
    try {
      if (st) st.setProperty('scroll-behavior', 'auto', 'important');
      try {
        window.scrollTo({ top: window.scrollY + dy, left: window.scrollX, behavior: 'instant' });
      } catch (e) {
        window.scrollBy(0, dy);
      }
    } finally {
      if (st) {
        if (prev) st.setProperty('scroll-behavior', prev, prio);
        else st.removeProperty('scroll-behavior');
        if (!root.getAttribute('style')) root.removeAttribute('style');
      }
    }
  }

  function rvfyRestoreAnchor(sec, a) {
    try {
      var dy = null;
      var pinEl = null;
      var pinTop = 0;
      if (a.cands && a.primary >= 0 && a.primary < a.cands.length) {
        var byId = {};
        var cards = sec.querySelectorAll('.reviewify-card[data-rvfy-id]');
        for (var i = 0; i < cards.length; i++) {
          var cid = cards[i].getAttribute('data-rvfy-id');
          if (!rvfyHas(byId, cid)) byId[cid] = cards[i];
        }
        var want = a.cands[a.primary];
        // The card being read where it was; deleted: the next surviving card
        // of the old list takes ITS place (never a card's own old offset —
        // one never on screen would throw the reader off by its height).
        for (var c = a.primary; c < a.cands.length && dy === null; c++) {
          var el = rvfyHas(byId, a.cands[c].id) ? byId[a.cands[c].id] : null;
          if (el && el.getBoundingClientRect().height > 0) { dy = el.getBoundingClientRect().top - want.top; pinEl = el; pinTop = want.top; }
        }
      }
      if (dy === null && a.el && a.el.parentNode) { dy = a.el.getBoundingClientRect().top - a.top; pinEl = a.el; pinTop = a.top; }
      if (dy === null && a.after) dy = sec.getBoundingClientRect().bottom - a.top;
      // The section top holds the view, or nothing recorded is drawn any
      // more: the same offset relative to the section.
      if (dy === null && typeof a.secTop === 'number') { dy = sec.getBoundingClientRect().top - a.secTop; pinEl = sec; pinTop = a.secTop; }
      dy = Math.round(dy || 0);
      if (dy) rvfyScrollByInstant(dy);
      if (pinEl) rvfyHoldAnchor(pinEl, pinTop);
    } catch (e) { /* never break the page over a scroll correction */ }
  }

  // For a short while after an in-place rebuild the new section still
  // settles (a photo that fails is taken out, a relayout in the next frame,
  // a cached photo decodes) — and on a masonry grid the browser's own scroll
  // anchoring is off (the grid's height changes). Keep the anchored element
  // where it was, frame by frame, for 2 s at most; the reader scrolling (or
  // touching, clicking, typing) ends it at once.
  var rvfyHold = null;
  function rvfyHoldAnchor(el, top) {
    var raf = window.requestAnimationFrame;
    if (typeof raf !== 'function') return;
    if (rvfyHold) rvfyHold.stop();
    var h = { on: true, y: window.scrollY };
    var until = Date.now() + 2000;
    var evs = ['wheel', 'touchstart', 'keydown', 'mousedown'];
    h.stop = function() {
      if (!h.on) return;
      h.on = false;
      for (var i = 0; i < evs.length; i++) window.removeEventListener(evs[i], h.stop, true);
      if (rvfyHold === h) rvfyHold = null;
    };
    for (var i = 0; i < evs.length; i++) window.addEventListener(evs[i], h.stop, true);
    rvfyHold = h;
    var tick = function() {
      if (!h.on) return;
      if (Date.now() > until || !el.parentNode || Math.abs(window.scrollY - h.y) > 1) { h.stop(); return; }
      var d = Math.round(el.getBoundingClientRect().top - top);
      if (d) { rvfyScrollByInstant(d); h.y = window.scrollY; }
      raf(tick);
    };
    raf(tick);
  }

  // One resize listener per page: re-lays out whichever section is current
  // (its state — rvfyActiveLayout … — is declared at the top: the saved copy
  // is drawn before this point of the script runs).
  function rvfyBindResize() {
    if (rvfyResizeBound) return;
    rvfyResizeBound = true;
    window.addEventListener('resize', function() {
      if (rvfyResizeTimer) clearTimeout(rvfyResizeTimer);
      rvfyResizeTimer = setTimeout(function() { rvfyResizeTimer = null; if (rvfyActiveLayout) rvfyActiveLayout(); }, 100);
    });
  }

  // ── Render a single review card ──
  // Layout mirrors WiseReviews:
  //   1. Buyer photos (large thumbnails) at the top of the card
  //   2. Star rating
  //   3. Reviewer avatar (small circle) + name + verified badge
  //   4. Review text
  //   5. Date + helpful button
  function renderReviewCard(review) {
    var html = '<div class="reviewify-card" data-rvfy-id="' + escapeHtml(String(review.id)) + '">';
    
    // ── Buyer photos (large, above review text) ──
    // These are product photos uploaded by the buyer (NOT the reviewer avatar).
    // Widget v5: sized to the card (square crop, 1x/2x), lazy, async decode,
    // width/height as a ratio hint; photos that already failed are skipped.
    var photos = rvfyLive(review.buyerPhotos);
    if (photos.length > 0) {
      var setKey = 'r' + review.id;
      rvfySets[setKey] = photos;
      var cw = rvfyCardImgW || 280;
      var side = String(Math.round(cw));
      html += '<div class="reviewify-card-photos">';
      html += rvfyImgTag(photos[0], cw, cw, 'crop', 'alt="Buyer photo" class="reviewify-card-photo" width="' + side + '" height="' + side + '" data-rvfy-set="' + escapeHtml(setKey) + '" data-rvfy-index="0" loading="lazy" decoding="async" style="display:block;width:100%;max-width:100%;aspect-ratio:1/1;height:auto;object-fit:cover;cursor:pointer"');
      if (photos.length > 1) {
        html += '<div class="reviewify-card-photo-row">';
        var maxThumbs = Math.min(photos.length, 4);
        for (var bp = 1; bp < maxThumbs; bp++) {
          html += rvfyImgTag(photos[bp], 48, 48, 'crop', 'alt="Buyer photo" class="reviewify-card-photo-sm" width="48" height="48" style="width:48px;height:48px;max-width:48px;object-fit:cover" data-rvfy-set="' + escapeHtml(setKey) + '" data-rvfy-index="' + bp + '" loading="lazy" decoding="async"');
        }
        if (photos.length > 4) {
          html += '<span class="reviewify-photo-count">+' + (photos.length - 4) + '</span>';
        }
        html += '</div>';
      }
      html += '</div>';
    }
    
    // ── Stars ──
    html += '<div class="reviewify-card-stars">' + renderStars(review.rating) + '</div>';
    
    // ── Reviewer info: small avatar circle + name + verified badge ──
    html += '<div class="reviewify-card-reviewer">';
    if (review.reviewerAvatar && !rvfyHas(rvfyBroken, review.reviewerAvatar)) {
      html += rvfyImgTag(review.reviewerAvatar, 32, 32, 'crop', 'alt="" class="reviewify-avatar" width="32" height="32" style="width:32px;height:32px;max-width:32px;object-fit:cover" loading="lazy" decoding="async"');
    } else {
      html += rvfyAvatarPlaceholder(review.reviewerName);
    }
    html += '<span class="reviewify-reviewer-name">' + escapeHtml(review.reviewerName) + '</span>';
    if (review.verifiedPurchase) {
      html += '<span class="reviewify-verified" title="Verified Purchase">&#10003; Verified</span>';
    }
    html += '</div>';
    
    // ── Review text ──
    if (review.reviewText) {
      var text = review.reviewText;
      var truncated = text.length > 150;
      if (truncated) {
        html += '<p class="reviewify-card-text" data-full="' + escapeHtml(text).replace(/"/g, '&quot;') + '" data-short="' + escapeHtml(text.substring(0, 150)).replace(/"/g, '&quot;') + '...">' + escapeHtml(text.substring(0, 150)) + '...</p>';
        html += '<button class="reviewify-read-more" data-expanded="0">Read more</button>';
      } else {
        html += '<p class="reviewify-card-text">' + escapeHtml(text) + '</p>';
      }
    }
    
    // ── Date ──
    // Widget v6: one format ("Aug 30, 2026") for every date it can parse —
    // ISO and named dates were mixed on one widget; anything else as stored.
    if (review.reviewDate) {
      html += '<div class="reviewify-card-date">' + escapeHtml(rvfyFormatReviewDate(review.reviewDate)) + '</div>';
    }
    
    // ── Helpful button ──
    // Stateful per-visitor toggle persisted in localStorage (no server round-trip,
    // no shared count to fake). renderReviewCard reflects the saved state on load.
    var helpfulKey = 'reviewify_helpful_' + review.id;
    var alreadyHelpful = false;
    try { alreadyHelpful = window.localStorage.getItem(helpfulKey) === '1'; } catch (e) {}
    html += '<button class="reviewify-helpful' + (alreadyHelpful ? ' reviewify-helpful-active' : '') +
      '" data-rvfy-helpful="' + review.id + '" aria-pressed="' + (alreadyHelpful ? 'true' : 'false') + '">' +
      (alreadyHelpful ? '✓ Helpful' : 'Helpful') + '</button>';

    html += '</div>';
    return html;
  }

  // ── Render star SVGs ──
  // Widget v6: the last star is filled to the REAL fraction (4.8 = four stars
  // and 80 % of the fifth — it showed as 4½ before), each partial star with
  // its own gradient id (the same id twice on a page paints the wrong fill).
  // Every star keeps width/height and its own fill (the v4 black-star fix).
  // A function, not a variable: the saved copy is drawn before this point of
  // the script runs (a top-level var here would still be undefined).
  function rvfyStarPoly(fill) {
    return '<polygon points="10,1 12.5,7.5 19.5,7.5 14,12 16,19 10,15 4,19 6,12 0.5,7.5 7.5,7.5" fill="' + fill + '"/>';
  }
  function renderStars(rating) {
    var fills = rvfyStarFills(rating);
    var html = '<span class="reviewify-stars">';
    for (var i = 0; i < 5; i++) {
      var f = fills[i];
      if (f >= 1) {
        html += '<svg class="reviewify-star reviewify-star-full" viewBox="0 0 20 20" width="16" height="16">' + rvfyStarPoly('#f4c01e') + '</svg>';
      } else if (f > 0) {
        var gid = 'reviewify-star-g' + (++rvfyGradSeq);
        var pct = Math.round(f * 100) + '%';
        html += '<svg class="reviewify-star reviewify-star-half" viewBox="0 0 20 20" width="16" height="16"><defs><linearGradient id="' + gid + '"><stop offset="' + pct + '" stop-color="#f4c01e"/><stop offset="' + pct + '" stop-color="#e0e0e0"/></linearGradient></defs>' + rvfyStarPoly('url(#' + gid + ')') + '</svg>';
      } else {
        html += '<svg class="reviewify-star reviewify-star-empty" viewBox="0 0 20 20" width="16" height="16">' + rvfyStarPoly('#e0e0e0') + '</svg>';
      }
    }
    html += '</span>';
    return html;
  }

  // ── Lightbox/Modal for buyer photos ──
  // Uses Shadow DOM for complete CSS isolation from Shopify themes.
  // No Shopify theme CSS can penetrate into the shadow root.
  var lightboxHost = null;
  var lightboxShadow = null;
  var lightboxPhotos = [];
  var lightboxIndex = 0;

  function createLightboxEl() {
    // Remove any stale host from previous loads
    var existing = document.getElementById('reviewify-lightbox-host');
    if (existing) existing.parentNode.removeChild(existing);

    // Create host element — minimal inline styles, just positioning
    var host = document.createElement('div');
    host.id = 'reviewify-lightbox-host';
    host.style.cssText = 'display:none !important;position:fixed;top:0;left:0;width:0;height:0;z-index:2147483647;pointer-events:none;';

    // Attach Shadow DOM — this creates a CSS-isolated boundary
    var shadow = host.attachShadow({ mode: 'open' });

    // All styles inside shadow root — completely isolated from Shopify
    var styleTag = document.createElement('style');
    styleTag.textContent = [
      ':host { all: initial; }',
      '.rvfy-lb-overlay {',
      '  position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;',
      '  background: rgba(0,0,0,0.9); z-index: 2147483647;',
      '  display: none; align-items: center; justify-content: center;',
      '  margin: 0; padding: 0; border: none; box-sizing: border-box;',
      '  overflow: hidden; pointer-events: auto; cursor: pointer;',
      '  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;',
      '}',
      '.rvfy-lb-overlay.rvfy-lb-open { display: flex; }',
      '.rvfy-lb-close {',
      '  position: absolute; top: 16px; right: 20px; z-index: 10;',
      '  background: rgba(0,0,0,0.6); border: 2px solid rgba(255,255,255,0.6);',
      '  color: #fff; font-size: 28px; line-height: 1; cursor: pointer;',
      '  padding: 0; border-radius: 50%; font-family: Arial, sans-serif;',
      '  width: 44px; height: 44px; display: flex; align-items: center;',
      '  justify-content: center; transition: background 0.2s;',
      '}',
      '.rvfy-lb-close:hover { background: rgba(255,255,255,0.2); }',
      '.rvfy-lb-nav {',
      '  position: absolute; top: 50%; z-index: 10;',
      '  transform: translateY(-50%);',
      '  background: rgba(255,255,255,0.15); border: none;',
      '  color: #fff; font-size: 36px; line-height: 1;',
      '  width: 52px; height: 52px; border-radius: 50%;',
      '  cursor: pointer; display: none; align-items: center;',
      '  justify-content: center; transition: background 0.2s;',
      '}',
      '.rvfy-lb-nav:hover { background: rgba(255,255,255,0.3); }',
      '.rvfy-lb-nav.rvfy-lb-show { display: flex; }',
      '.rvfy-lb-prev { left: 16px; }',
      '.rvfy-lb-next { right: 16px; }',
      '.rvfy-lb-img-wrap {',
      '  position: relative; z-index: 2; max-width: 92vw; max-height: 88vh;',
      '  display: flex; align-items: center; justify-content: center;',
      '  pointer-events: none;',
      '}',
      '.rvfy-lb-img {',
      '  max-width: 90vw; max-height: 85vh; object-fit: contain;',
      '  border-radius: 8px; box-shadow: 0 8px 40px rgba(0,0,0,0.5);',
      '  pointer-events: auto; cursor: default;',
      '}',
      '.rvfy-lb-counter {',
      '  position: absolute; bottom: 20px; left: 50%;',
      '  transform: translateX(-50%); z-index: 10;',
      '  color: #fff; font-size: 14px; font-weight: 600;',
      '  background: rgba(0,0,0,0.6); padding: 6px 18px;',
      '  border-radius: 20px; display: none;',
      '}',
      '.rvfy-lb-counter.rvfy-lb-show { display: block; }',
      // The stage pairs the main image with a thumbnail rail of the SAME
      // photo set, so a multi-photo review shows all its photos at a glance.
      '.rvfy-lb-stage {',
      '  position: relative; z-index: 2; display: flex; align-items: center;',
      '  justify-content: center; gap: 14px; max-width: 92vw; max-height: 88vh;',
      '  pointer-events: none;',
      '}',
      '.rvfy-lb-thumbs {',
      '  display: none; flex-direction: column; gap: 8px; overflow-y: auto;',
      '  max-height: 82vh; padding: 4px; pointer-events: auto;',
      '  scrollbar-width: thin;',
      '}',
      '.rvfy-lb-thumbs.rvfy-lb-show { display: flex; }',
      '.rvfy-lb-thumb {',
      '  width: 56px; height: 56px; object-fit: cover; border-radius: 8px;',
      '  cursor: pointer; border: 2px solid transparent; opacity: 0.55;',
      '  flex: 0 0 auto; transition: opacity 0.15s, border-color 0.15s;',
      '  background: rgba(255,255,255,0.12); color: transparent;',
      '}',
      '.rvfy-lb-thumb:hover { opacity: 0.85; }',
      '.rvfy-lb-thumb.rvfy-lb-thumb-active { border-color: #fff; opacity: 1; }',
      '.rvfy-lb-stage.rvfy-lb-has-thumbs .rvfy-lb-img { max-width: 80vw; }',
      '@media (max-width: 640px) {',
      '  .rvfy-lb-stage { flex-direction: column; gap: 10px; }',
      '  .rvfy-lb-stage.rvfy-lb-has-thumbs .rvfy-lb-img { max-width: 90vw; max-height: 68vh; }',
      '  .rvfy-lb-thumbs {',
      '    flex-direction: row; overflow-x: auto; overflow-y: hidden;',
      '    max-width: 90vw; max-height: none;',
      '  }',
      '  .rvfy-lb-thumb { width: 48px; height: 48px; }',
      '}',
    ].join('\n');
    shadow.appendChild(styleTag);

    // Build the overlay DOM inside shadow root
    var overlay = document.createElement('div');
    overlay.className = 'rvfy-lb-overlay';
    overlay.innerHTML = [
      '<button class="rvfy-lb-close" aria-label="Close">&times;</button>',
      '<button class="rvfy-lb-nav rvfy-lb-prev" aria-label="Previous">&#8249;</button>',
      '<div class="rvfy-lb-stage">',
      '<div class="rvfy-lb-img-wrap"><img class="rvfy-lb-img" src="" alt="Buyer photo" /></div>',
      '<div class="rvfy-lb-thumbs"></div>',
      '</div>',
      '<button class="rvfy-lb-nav rvfy-lb-next" aria-label="Next">&#8250;</button>',
      '<div class="rvfy-lb-counter"></div>',
    ].join('');
    shadow.appendChild(overlay);

    // A photo that cannot be shown: its fallback address once, then the next
    // photo (or the lightbox closes when none is left) — never a broken icon.
    var lbMain = shadow.querySelector('.rvfy-lb-img');
    lbMain.addEventListener('load', function() { rvfyNoteLoaded(lbMain); });
    lbMain.addEventListener('error', function() {
      if (!lbMain.getAttribute('src')) return;
      if (rvfyTryFallback(lbMain)) return;
      // Dropped from THIS lightbox only; marked broken for the page only
      // when it never loaded here and no element on the page shows it (a
      // flaky connection must not remove a photo the shopper has seen).
      var base = lbMain.getAttribute('data-rvfy-u');
      if (base) rvfyMarkBroken(base, null);
      var at = lightboxPhotos.indexOf(base);
      if (at >= 0) lightboxPhotos.splice(at, 1);
      if (!lightboxPhotos.length) { closeLightbox(); return; }
      if (lightboxIndex >= lightboxPhotos.length) lightboxIndex = 0;
      renderLightboxThumbs();
      updateLightboxImage();
    });

    // Append host to documentElement
    (document.documentElement || document.body).appendChild(host);

    // Event listeners inside shadow DOM
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        e.preventDefault();
        e.stopPropagation();
        closeLightbox();
      }
    });
    shadow.querySelector('.rvfy-lb-close').addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeLightbox();
    });
    shadow.querySelector('.rvfy-lb-prev').addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      lightboxIndex = (lightboxIndex - 1 + lightboxPhotos.length) % lightboxPhotos.length;
      updateLightboxImage();
    });
    shadow.querySelector('.rvfy-lb-next').addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      lightboxIndex = (lightboxIndex + 1) % lightboxPhotos.length;
      updateLightboxImage();
    });

    lightboxHost = host;
    lightboxShadow = shadow;
    return host;
  }

  function openLightbox(photos, startIndex) {
    lightboxPhotos = photos;
    lightboxIndex = startIndex || 0;
    if (!lightboxHost) {
      createLightboxEl();
    }
    renderLightboxThumbs();
    updateLightboxImage();
    // Show the overlay by adding the open class
    var overlay = lightboxShadow.querySelector('.rvfy-lb-overlay');
    overlay.classList.add('rvfy-lb-open');
    // Make host intercept pointer events
    lightboxHost.style.cssText = 'display:block !important;position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:2147483647;pointer-events:auto;';
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', lightboxKeyHandler);
  }

  // Rebuild the thumbnail rail for the CURRENT photo set — one thumb per
  // photo, click to jump. Called on every open (the set changes per review).
  function renderLightboxThumbs() {
    if (!lightboxShadow) return;
    var rail = lightboxShadow.querySelector('.rvfy-lb-thumbs');
    var stage = lightboxShadow.querySelector('.rvfy-lb-stage');
    if (!rail || !stage) return;
    rail.innerHTML = '';
    if (lightboxPhotos.length > 1) {
      // 56 px rail (48 px on phones): 1x/2x from the store's own files.
      var railBox = rvfyLightboxPhone() ? 48 : 56;
      for (var i = 0; i < lightboxPhotos.length; i++) {
        (function(idx) {
          var t = document.createElement('img');
          t.className = 'rvfy-lb-thumb';
          t.alt = 'Photo ' + (idx + 1);
          t.setAttribute('width', String(railBox));
          t.setAttribute('height', String(railBox));
          t.setAttribute('loading', 'lazy');
          t.setAttribute('decoding', 'async');
          t.setAttribute('data-rvfy-idx', String(idx));
          // A rail thumbnail that cannot load is hidden (the rail stays aligned
          // with the photo list); its fallback never moves the main image.
          t.addEventListener('error', function() {
            if (rvfyTryFallback(t, false)) return;
            t.style.display = 'none';
          });
          t.addEventListener('load', function() { rvfyNoteLoaded(t); });
          rvfySetImg(t, lightboxPhotos[idx], railBox, railBox, 'crop');
          t.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            lightboxIndex = idx;
            updateLightboxImage();
          });
          rail.appendChild(t);
        })(i);
      }
      rail.classList.add('rvfy-lb-show');
      stage.classList.add('rvfy-lb-has-thumbs');
    } else {
      rail.classList.remove('rvfy-lb-show');
      stage.classList.remove('rvfy-lb-has-thumbs');
    }
  }

  function rvfyLightboxPhone() {
    return (window.innerWidth || 1200) <= 640;
  }

  // The main image box (the lightbox CSS: 90vw × 85vh; 80vw beside the
  // thumbnail rail; 68vh under it on phones) × min(devicePixelRatio, 2).
  // Shopify FITS the image inside width × height (no crop), capped at 1600;
  // our storage copies pick their -w1280 / -w640 size (both preloadable). An
  // address that cannot be resized keeps its own, with the small size tokens
  // raised for a big box (rvfyLightboxPick).
  function rvfyLightboxSrc(u) {
    var d = Math.min(window.devicePixelRatio || 1, 2);
    var rail = lightboxPhotos.length > 1;
    var phone = rvfyLightboxPhone();
    var boxW = (window.innerWidth || 1200) * (rail && !phone ? 0.8 : 0.9);
    var boxH = (window.innerHeight || 900) * (rail && phone ? 0.68 : 0.85);
    return rvfyLightboxPick(u, boxW * d, boxH * d);
  }

  function updateLightboxImage() {
    if (!lightboxShadow) return;
    var img = lightboxShadow.querySelector('.rvfy-lb-img');
    var src = lightboxPhotos[lightboxIndex] || '';
    var main = rvfyLightboxSrc(src);
    img.setAttribute('decoding', 'async');
    img.setAttribute('data-rvfy-u', src);
    img.removeAttribute('srcset');
    if (main.fb && !rvfyHas(rvfyFallbackUsed, src)) img.setAttribute('data-rvfy-fb-src', main.fb); else img.removeAttribute('data-rvfy-fb-src');
    img.src = rvfyHas(rvfyFallbackUsed, src) && main.fb ? main.fb : main.src;
    // The neighbours load in the background with the IDENTICAL address, so
    // moving to them is instant (no new request) — only sized addresses: a
    // full-size original that cannot be resized is never preloaded (it would
    // compete with the photo the shopper is waiting for).
    if (lightboxPhotos.length > 1) {
      var nb = [lightboxPhotos[(lightboxIndex + 1) % lightboxPhotos.length], lightboxPhotos[(lightboxIndex - 1 + lightboxPhotos.length) % lightboxPhotos.length]];
      for (var ni = 0; ni < nb.length; ni++) {
        if (!nb[ni] || nb[ni] === src) continue;
        var ps = rvfyLightboxSrc(nb[ni]);
        if (!ps.sized) continue;
        var pre = new Image();
        pre.src = rvfyHas(rvfyFallbackUsed, nb[ni]) && ps.fb ? ps.fb : ps.src;
      }
    }
    var counter = lightboxShadow.querySelector('.rvfy-lb-counter');
    var prevBtn = lightboxShadow.querySelector('.rvfy-lb-prev');
    var nextBtn = lightboxShadow.querySelector('.rvfy-lb-next');
    if (lightboxPhotos.length > 1) {
      counter.textContent = (lightboxIndex + 1) + ' / ' + lightboxPhotos.length;
      counter.classList.add('rvfy-lb-show');
      prevBtn.classList.add('rvfy-lb-show');
      nextBtn.classList.add('rvfy-lb-show');
    } else {
      counter.classList.remove('rvfy-lb-show');
      prevBtn.classList.remove('rvfy-lb-show');
      nextBtn.classList.remove('rvfy-lb-show');
    }
    // Highlight the active thumb (by its own index: a hidden thumbnail never
    // shifts the others) and keep it in view on long rails.
    var thumbs = lightboxShadow.querySelectorAll('.rvfy-lb-thumb');
    for (var ti = 0; ti < thumbs.length; ti++) {
      if (thumbs[ti].getAttribute('data-rvfy-idx') === String(lightboxIndex) && thumbs[ti].style.display !== 'none') {
        thumbs[ti].classList.add('rvfy-lb-thumb-active');
        try { thumbs[ti].scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
      } else {
        thumbs[ti].classList.remove('rvfy-lb-thumb-active');
      }
    }
  }

  function closeLightbox() {
    if (!lightboxShadow) return;
    var overlay = lightboxShadow.querySelector('.rvfy-lb-overlay');
    overlay.classList.remove('rvfy-lb-open');
    // Shrink host back to zero so it doesn't block page interaction
    lightboxHost.style.cssText = 'display:none !important;position:fixed;top:0;left:0;width:0;height:0;z-index:2147483647;pointer-events:none;';
    document.body.style.overflow = '';
    document.removeEventListener('keydown', lightboxKeyHandler);
  }

  function lightboxKeyHandler(e) {
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') {
      lightboxIndex = (lightboxIndex - 1 + lightboxPhotos.length) % lightboxPhotos.length;
      updateLightboxImage();
    }
    if (e.key === 'ArrowRight') {
      lightboxIndex = (lightboxIndex + 1) % lightboxPhotos.length;
      updateLightboxImage();
    }
  }

  // ── Helpers ──
  function getInitials(name) {
    if (!name) return '?';
    var parts = name.trim().split(/\s+/);
    if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
})();
